import React from "react";
import styled from "@emotion/styled";
import BackHeader from "@components/header/BackHeader";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

const Container = styled.div(({ theme }) => ({
  width: "100%",
  height: "100%",
  backgroundColor: "white",
}));

const ContentWrapper = styled.div(({ theme }) => ({
  padding: "2rem",

  u: {
    textDecoration: "underline",
    fontWeight: "normal",
  },

  h1: {
    fontSize: "2.4rem",
    fontWeight: 600,
    marginBottom: "2rem",
  },

  h2: {
    fontSize: "2rem",
    fontWeight: 600,
    marginBottom: "1.6rem",
    marginTop: "3.2rem",
  },

  p: {
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    marginBottom: "1.6rem",
  },

  "ul, ol": {
    paddingLeft: "2rem",
    marginBottom: "1.6rem",
  },

  li: {
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    marginBottom: "0.8rem",
    listStyle: "decimal",
  },

  "ul > li": {
    listStyle: "disc", // 글머리 기호
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: "2rem",

    "th, td": {
      border: `1px solid ${theme.color.border_gray}`,
      padding: "1.2rem",
      fontSize: "1.4rem",
      lineHeight: "2rem",
    },

    th: {
      backgroundColor: theme.color.light_gray,
      fontWeight: 500,
    },
  },
}));

const TermsMarkdown = `
# SHAKALAKA 서비스 이용약관

# 일반 이용약관

샤카라카에 오신 것을 환영합니다!

아래 명시된 문서들은 귀하(이하 ‘이용자’ 라고 함)의 주식회사 아울소싸이어티가 제공하는 모바일 애플리케이션 서비스 샤카라카(이하 ’서비스’라고 함)의 이용을 규율하는 조건들을 명시합니다.
귀하가 당사 서비스를 이용하기 전에, 귀하가 법적 권리와 의무 및 귀하에 적용되는 조건, 제한사항 및 예외사항을 이해할 수 있도록 귀하에 관련된 문서를 정독하시기 바랍니다.
당사 서비스를 이용함으로써(당사 웹사이트를 단순 브라우징하는 경우 포함), 귀하는 귀하에 적용 되는 모든 조건들을 준수하기로 합니다

# **서비스 이용약관**
해당 조건은 귀하의 서비스 가입 여부나 계정 설정 여부 또는 귀하가 상품의 구매나 판매 여부에 관계없이 모든 이용자들에게 적용됩니다.

## **서비스 이용약관의 내용**

(주)아울소싸이어티는 대한민국에서 설립된 법인회사로 경기도 수원시 효원로 249번길 46-15, 5F 55 에 등록된 주소를 두고 있으며, 681-86-02211로 사업자 등록이 되어 있다. 모바일 어플리케이션 ‘샤카라카 SHAKALAKA’, 웹사이트 ‘샤카라카 프로젝트’ 및 서비스 소개 웹사이트 ’www.shakalaka.kr’ (이하 모두 ‘서비스’라고 함)에 대한 모든 권리를 소유한다.
본 약관은 서비스의 모든 이용자들에게 적용된다. 본 약관은 샤카라카가 이용자들로 하여금 서비스에 액세스하여 다양한 기능을 이용할 수 있게 하는 조건을 규정한다. 본 약관은 이용자의 권리 및 의무에 관한 사항을 규정하며, 따라서 모든 이용자들에게 서비스를 이용하기 전에 자신에게 적용되는 본 약관을 숙독하고 이를 이해할 것을 권장한다.

## 1. 계정 생성

서비스의 기능에 액세스하기 위해, 이용자들은 자신의 이메일 주소와 비밀번호를 사용하거나 소셜 로그인 기능을 사용하여 계정을 생성하고, 필요에 따라 휴대폰 본인 인증을 해야 한다. 이용자들은 계정 생성 과정에서 최신의 정확한 정보를 입력하기로 한다. 

계정 생성은 무료이며, 서비스에서 구매 또는 판매해야 하는 의무는 발생하지 아니한다. 이용자들은 반드시 만 18세 이상이어야 하며, 판매를 진행할 수 있는 완전한 법적 능력을 갖추어야 한다.

등록 완료 시, 이용자들은 자신이 서비스에 등록시 설정한 이메일 주소 및 비밀번호를 이용하여 자신의 계정에 액세스하여 이를 이용할 수 있다. 이러한 식별자는 항상 이용자들이 책임을 부담하는 것으로 세션 오픈시마다 입력되어야 하며, 이용자들은 이를 제3자에게 공개하거나 제3자로 하여금 이를 이용하도록 허락해서는 아니된다. 이용자들은 자신의 신원이나 제3자의 신원으로 처음에 설정한 계정이 아닌 어떠한 계정도 생성하거나 이용하지 않기로 한다. 이용자들은 서비스가 아닌 다른 전자상거래 웹사이트를 식별하는 수단을 제공하는 사용자명을 선택하지 않기로한다. 이용자가 위 금지사항을 준수하지 않는 경우, 서비스는 해당 이용자의 계정을 즉시 폐쇄할 수 있는 권리를 가진다.

___여기부터
이용자들은 제3자에 의한 자신의 사용자명, 식별자 및/또는 비밀번호의 부정사용에 대해 알게 된
후 가능한 한 신속하게 [http://faq.vestiairecollective.com](http://faq.vestiairecollective.com/) FAQ 문의양식을 통해 베스티에르 콜렉티브
에 통지하기로 한다. 관련 이용자가 해당 이용을 승인하였거나 이에 대해 알고 있었을 경우, 여하
한 타인이 이용자의 이 웹사이트 계정 내 정보에 액세스함으로써 베스티에르 콜렉티브가 손해나
손실을 입거나 비용을 부담하는 경우, 이용자들은 베스티에르 콜렉티브에 배상하기로 한다.
이용자들은 이 웹사이트에 등록하기 위해 Facebook Connect 기능을 사용하는 경우 이용자들에게
베스티에르 콜렉티브가 해당 이용자의 Facebook 계정에 관한 특정 정보(성명, Facebook 식별자, 이
메일 주소, 성별, 생년월일, 프로필 사진, 친구 목록 및 이용자들의 Facebook 계정에 포함된 모든 기
타 공개 정보 등)에 액세스할 수 있게 허용할 지에 관한 질문을 받게 됨을 확인한다. 보다 상세한
정보를 원하는 경우, 베스티에르 콜렉티브 개인정보보호방침 및 쿠키를 참조한다.
이용자들은 현재 “이용자 검색(find by user)” 툴로 베스티에르 콜렉티브 커뮤니티의 다른 회원들
을 검색할 수 있다. 이용자들은 (1) 사용자명 및 (2) 이름을 사용하여 다른 이용자들을 검색할 수 있
웹사이트 이용약관 – 2020년 7월 21일
다. 이용자의 성 또는 이메일 주소를 사용하여 검색하는 것은 불가능하다. 베스티에르 콜렉티브 회
원들에 한해서만 사용자명을 공개적으로 검색할 수 있다. 사용자명은 자동으로 생성된다(이용자
들이 보다 쉽게 귀하를 검색할 수 있도록 업데이트 할 수 있음). 원하는 경우 횟수 제한없이 언제라
도 사용자명을 변경할 수 있다. 사용자명은 고유한 것으로, 어느 이용자도 동일한 사용자명을 가질
수 없다.


1. 소개
이 웹사이트의 이용자는 제3자가 이 웹사이트에서 제공되는 상품 및 서비스로부터 혜택을 누리고
이 웹사이트에 등록할 수 있도록 소개에 관한 규칙에 따라 제3자를 스폰서 할 수 있다. 베스티에르
콜렉티브 소개 프로그램의 목적상, 이 웹사이트에서 제공되는 제품 및 서비스에 대한 제안을 받기
위해 이 웹사이트에 가입하거나 이 웹사이트 상에서 확인된 거래를 수행하는 자들은 모두 이용자
로 간주된다. 스폰서를 받는 자는 “스폰서대상자”로 간주되며, 베스티에르 콜렉티브의 서비스를
추천하는 이용자들은 “스폰서”로 간주된다. 스폰서 및 스폰서대상자에는 소개에 관한 규칙에 부
합하는 방식으로 베스티에르 콜렉티브가 정한 조건에 따라 특정 권리가 허여된다.
2. 이 웹사이트 이용 과정에서의 베스티에르 콜렉티브의 역할 및 책임
이용자들은 자신의 모든 행위 및 이용자들이 이 웹사이트에 게시하는 모든 이용자 콘텐츠가 이용
자들에 적용되는 법령을 준수하도록 할 책임을 진다.
베스티에르 콜렉티브는 이 웹사이트 상에서 이용자가 수행하는 활동으로 인해 발생하는 모든 손
해 및 손실(데이터 손실, 판매기회나 구매기회의 손실, 수입, 이익, 사업활동, 기회나 고객 손실, 이
용자의 평판손실이나 활동중단에 대한 손해 및 이용자가 부담하는 간접 손실이나 손해, 또는 이용
자(또는 이용자를 대리하는 자)의 작위나 부작위로 인해 발생하거나 불가항력으로 인해 발생하는
자신의 의무 이행에 대한 방해나 지연을 포함하되 한정되지 아니함)에 대한 책임을 부인한다.
베스티에르 콜렉티브는 이 웹사이트에서 액세스할 수 있는 제3자 웹사이트에서 호스팅되는 콘텐
츠에 대한 책임을 지지 않으며, 이는 해당 제3자 사이트의 책임으로 한다. 제3자 웹사이트에서 호
스팅되는 콘텐츠에 대한 지식재산권을 보유한 이용자가 자신의 콘텐츠 사용을 승인하지 않고자
하는 경우, 해당 제3자 웹사이트의 관리자에게 직접 연락하여 해당 웹사이트에서 문제의 콘텐츠를
삭제하도록 요청하는 것은 이용자의 판단사항이다.
베스티에르 콜렉티브는 컴퓨터 바이러스, 웜(worm), 시한폭탄(time bomb), 트로이 목마(Trojan
horse), 캔슬봇(cancelbot), 멀웨어(malware) 또는 기타 방식으로 컴퓨터의 성능을 손상, 파괴 또는
저하시키거나, 또는 컴퓨터 프로그램의 적절한 운영을 저해하도록 설계된 기타 프로그램(이용자
가 여하한 콘텐츠를 다운로드하여 발생하는 전송, 이용자가 이용한 소프트웨어 애플리케이션 또
는 이 웹사이트나 이에 액세스하기 위해 사용될 수 있는 서버의 콘텐츠를 다운로드하기 위해 이용
자가 이용하는 소프트웨어 애플리케이션 등)으로 인해 발생할 수 있는 손실이나 손해에 대한 보증
을 제공하지 아니한다. 이와 관련하여, 이용자들은 이용자들이 버그(bug), 바이러스 또는 여하한
기타 악성 프로그램으로부터 보호하기 위해 자신의 컴퓨터 장비 및 여하한 기타 시스템에 바이러
스방지 소프트웨어 및 적절한 보안 애플리케이션을 설치해야 할 책임이 있음을 확인한다.
3. 이용자 콘텐츠
5.1. 이용자 콘텐츠의 생성
이용자들은 상품페이지(“상품페이지”) 및 프로필 데이터시트(“프로필 데이터시트”)를 생성하고,
다른 이용자들이 온라인에 게시한 상품 관련 코멘트(“이용자 코멘트”)를 게시할 수 있다. 이용자들
이 생성 또는 게시한 모든 해당 요소들을 “이용자 콘텐츠”라 한다.
이용자들의 상품페이지 및/또는 프로필 데이터시트를 업로드함으로써, 이용자들은 베스티에르 콜
렉티브 및 그 모든 승계인들과 양수인들에게 다음과 같이 할 수 있는 권한을 부여한다:
- 이용자 콘텐츠를 해당 요소에 제공되는 보호기간 동안 모든 매체(“알림(Alert)” 및 “뉴스레
터(Newsletters)” 등 이 웹사이트 및 상업문서 포함)에서 모든 형식 및 방법으로 전세계에서
첨부, 저장, 복제, 배포 및 활용할 수 있는 권한;
- 사진의 크기를 조정하거나 크로핑(cropping)하고, 상품이 흰색 배경에 보이도록 상품의 배
경을 제거하는 등 사진상의 상품 외형을 수정할 수 있는 권한.
베스티에르 콜렉티브는 타인의 지식재산권을 존중하며, 따라서 이 웹사이트의 이용자들이 제3자
의 지식재산권을 침해하는 요소를 배포, 다운로드, 온라인 게시 또는 달리 전송하는 행위를 금지한
다.
이용자들은 이용자에 의한 지식재산권의 침해나 위반에 대해 제3자가 제기한 청구의 일부로 또는
이와 관련하여 베스티에르 콜렉티브가 부담한 모든 청구, 책임, 손해, 손실, 비용 및 지출(합리적인
금액 한도 내의 변호사 비용 포함)에 대해 베스티에르 콜렉티브 및 그 임원, 이사, 종업원, 대리인
및 공급자들을 보호하기로 한다.
보다 일반적으로, 이용자들은 자신의 상품페이지 및 이용자들이 이 웹사이트에서 판매를 위해 제
안하는 상품 설명의 내용과 관련하여 제3자들이 제기하는 모든 청구로부터 베스티에르 콜렉티브
를 보호한다.
5.2. 베스티에르 콜렉티브는 이용자 콘텐츠를 모니터링 하지 아니함
베스티에르 콜렉티브는 이용자 콘텐츠나 제3자 콘텐츠를 통제하지 아니하며, 따라서 이용자 콘텐
츠나 제3자 콘텐츠의 정확성이나 완전성에 대한 책임을 부인하며, 베스티에르 콜렉티브는 이 웹사
이트에 게시 또는 다운로드된 콘텐츠의 적절성을 확인해야 할 의무를 지지 아니한다. 베스티에르
콜렉티브는 항상 호스트로서만 행위하며, 상품페이지에 게시되거나 업로드되는 모든 콘텐츠를 비
롯하여 이용자들이 업로드하는 데이터나 정보에 대한 책임을 부인한다. 제3자의 권리 및/또는 이
웹사이트의 이용에 관한 사항을 규율하는 본 약관에 대한 위반이 발생하는 경우, 베스티에르 콜렉
티브는 모든 이용자 콘텐츠를 삭제할 수 있다.
이 웹사이트에 정보를 게시 또는 전송한 이용자만이 해당 정보에 대한 책임을 지며, 이러한 정보가
반드시 베스티에르 콜렉티브의 의견이나 원칙을 반영하는 것은 아니다. 따라서, 베스티에르 콜렉
티브는 해당 정보의 완전성 및 정확성을 보장하지 아니한다. 다른 이용자들이 게시하거나 업로드
한 정보에 기반하여 이용자가 내린 결정은 이용자 자신의 판단 및 자신의 단독 책임 하에 이루어진
독자적인 평가를 기초로 내려진 것이다.
5.3. 불법 콘텐츠나 지식재산권 침해에 관한 통지
어느 콘텐츠 및/또는 상품페이지에 타인의 명예를 훼손하거나 불법적인 메시지가 포함되어 있다
고 판단하거나, 이 웹사이트에 게시된 내용이나 정보에 의해 귀하의 지식재산권이 침해되었다고
판단하는 경우, [http://faq.vestiairecollective.com](http://faq.vestiairecollective.com/) FAQ 문의양식을 작성하여 해당 사항을 베스티에르
콜렉티브에 통지해야 한다.
베스티에르 콜렉티브는 지식재산권 침해 청구에 대해 가능한 한 신속하게 응대하고, 명백한 지식
재산권 침해 통지에 대해 조치를 취하는 것을 그 방침으로 한다. 지식재산권 침해에 관한 청구나
불만이 있는 경우, 해당 사항을 legal@vestiairecollective.com로 전달한다.
베스티에르 콜렉티브는 인터넷 상에서의 지식재산권 침해를 방지하는 프랑스 협약인 Charte de
lutte contre la contrefaçon sur Internet의 가맹사이다. 이를 위하여, 베스티에르 콜렉티브는 소비자들
및 권리보유자들 모두를 위해 위 협약에 명시된 지식재산권 침해를 방지하기 위한 절차를 적용하
기로 한다.
1. 개인 이미지에 대한 권리
프로필 데이터시트나 상품페이지가 생성되는 경우, 이용자들은 자신들을 표시하는 사진을 게시
할 수 있다. 본 약관에 동의함으로써, 이용자들은 이 웹사이트 운영 과정에서 이용자들의 이미지를
이용할 수 있는 권한을 베스티에르 콜렉티브에 허여한다.
이러한 권한의 허여는 이용자가 이 웹사이트 상에서 계정 및/또는 프로필 데이터시트를 가지고 있
는 전체 기간을 대상으로 한다. 이용자들은 [http://faq.vestiairecollective.com](http://faq.vestiairecollective.com/) 링크를 클릭하여 상기
조건에 따라 자신들의 이미지를 사용하도록 한 승인을 철회할 수 있다. 이용자들은 자신의 상품페
이지나 프로필 데이터시트를 생성하는 과정에서 사용된 사진이 이미지권에 대한 침해나 제3자들
의 개인정보에 대한 침해에 해당되지 아니함을 보장한다.
2. 개인정보
이용자들은 이용자들이 등록 과정에서 제공하는 정보가 적절하게 입력된 것으로 진실하고 정확함
을 보장한다. 베스티에르 콜렉티브는 베스티에르 콜렉티브가 이용자들의 이 웹사이트 이용 과정
에서, 또한 일반적으로 베스티에르 콜렉티브와 이용자들 간의 상업적 관계에서 취득한 이용자들
의 개인정보가 프랑스 및 유럽의 관계 법률에 따라 취급되고, 신의성실, 합법성, 투명성 및 비밀성
의 원칙에 따라 유지되어야 함을 확인한다.
개인정보의 처리에 관한 추가 정보는 베스티에르 콜렉티브 개인정보보호방침 및 쿠키를 참조한
다.
3. 이 웹사이트에 관한 지식재산 고지
이용자 콘텐츠를 제외한 이 웹사이트상의 모든 콘텐츠(시각·청각적 텍스트, 코멘트, 일러스트레
이션 및 이미지)는 전세계적으로 저작권, 상표 및/또는 특허 관련 법률에 의해 보호된다. 이 웹사이
트의 전부 또는 일부를 전부 또는 일부 복제하는 행위는 엄격히 금지되며, 베스티에르 콜렉티브 및
/또는 그 라이선서들의 지식재산권에 대한 침해로 간주된다.
4. 모범행위규칙
각 이용자는 이 웹사이트(및 이 웹사이트의 기존·장래 기능)를 합리적인 방식으로, 선의에 따라,
유효한 법령 및 본 약관의 조건에 부합하는 방식으로 이용하기로 한다. 특히, 이용자는 이 웹사이
트를 지식재산권(저작권, 상표법, 디자인 및 실용신안 관련 법률 등), 인격권(이미지, 존중, 사생활
등), 기본권 및 자유를 침해하는 방식으로 이용하지 않기로 한다. 이용자는 이 웹사이트 상에서의
자신의 행동이 다른 이용자들 및 베스티에르 콜렉티브에 대한 책임을 초래할 수 있음에 유의한다.
베스티에르 콜렉티브는 이 웹사이트상에서의 이용자들의 행동에 아무런 책임을 지지 아니한다.
필명을 선택하거나, 판매공지 및/또는 다른 이용자들과 주고받는 글을 작성하거나(특히, 인스턴트
메시지 툴인 “채팅(Chat)”을 사용하는 방식), 코멘트를 게시하는 방식 등으로 이 웹사이트를 통하
여 콘텐츠를 배포함에 있어, 각 이용자는 예의 바르고, 적절하며, 정중하게 행동하기로 한다. 특히,
각 이용자는 이 웹사이트에 인종차별적, 반유대주의적, 부정론적, 선정적, 폭력적, 음란, 외설적, 공
격적, 부적절, 혐오, 명예훼손적, 차별적, 희롱적이거나 또는 달리 불쾌한(이에 한정되지 아니함)
콘텐츠(및 특히 주요 배포 방식을 불문한 모든 코멘트, 메시지 및/또는 사진이나 동영상 콘텐츠)를
게시하지 않기로 한다. 베스티에르 콜렉티브는 베스티에르 콜렉티브가 부적절한 콘텐츠에 대해
알게 된 후 가능한 한 신속하게, 또는 부적절한 콘텐츠의 존재에 대해 통지를 받은 후 가능한 한 신
속하게, 베스티에르 콜렉티브가 사용하는 감지 알고리즘을 통해 자동화된 방식으로 부적절한 콘
텐츠를 삭제할 수 있는 권리를 가진다. 또한, 베스티에르 콜렉티브는 이용자에게 언제라도 이를 수
정(예컨대, 적절한 필명을 선택하는 등)하도록 요청할 수 있다.
일반적으로, 이 웹사이트를 이용함에 있어 다른 이용자 및/또는 베스티에르 콜렉티브(그 직원들
포함)를 기만하거나, 이들에게 오해나 충격을 초래하거나, 이들로부터 편취 또는 사취하거나, 또는
이들에게 해를 입힐 수 있는 이용자의 행위, 콘텐츠, 태도 및/또는 발언에는 베스티에르 콜렉티브
의 결정에 따라 (i) 모범행위규칙에 관한 안내문, (ii) 정식 통지, (iii) 이용자들 간의 메시지 툴에 대
한 액세스의 임시 정지나 영구적 중지, (iv) 이용자 계정의 정지나 영구적 정지가 적용될 수 있으며,
이는 손해배상청구권을 해하지 아니한다. 예컨대, 이는 다음의 경우를 포함한다:
- 이용자가 다른 이용자들이 제기한 불만이나 청구의 대상이 된 경우;
- 판매자인 이용자가 결함이 있거나, 또는 전반적으로 상품 시트에 불일치하는 상품을 1회
또는 수회 발송한 경우.
또한, 이용자들은 다른 이용자가 채팅을 통해 더 이상 자신에게 연락할 수 없도록 하기 위해 다른
이용자를 차단할 수 있는 선택권을 가진다. 베스티에르 콜렉티브는 채팅을 통해 전송되는 부적절
한 콘텐츠를 자동 감지하기 위한 알고리즘을 실행하고 있다.
상기 예시들에 한정됨 없이, 베스티에르 콜렉티브는 소송으로 이어질 수 있는 행위가 베스티에르
콜렉티브에 통지되는 경우 이 웹사이트를 관리할 수 있는 권리를 가진다.
이용자들은 이 웹사이트 밖에서, 또는 일반적으로 베스티에르 콜렉티브의 권리나 이익에 해가 되
는 방식으로, 상품에 관한 거래를 협상 및/또는 체결하기 위해 서로 연락하는 행위를 공식적으로
하지 아니한다. 또한, 이용자들은 베스티에르 콜렉티브의 서면 합의가 있는 경우를 제외하고 상품
이 판매될 수 있는 다른 웹사이트 및/또는 다른 웹사이트의 식별요소로 연결되는 링크를 유포하는
행위를 하지 아니한다. 이용자들은 이 웹사이트를 통해 개인이나 은행에 관한 정보를 공개하지 않
기로 한다. 특히, 이 웹사이트 상에서 판매를 위해 제안되는 상품에 관한 정보를 얻기 위한 목적 외
의 다른 목적으로 채팅을 사용해서는 아니된다.
이용자들은 제공된 서비스의 이미지를 폄하 또는 저해하고/하거나 베스티에르 콜렉티브(그 직원
들 포함) 및/또는 다른 이용자들의 평판을 해칠 수 있는 이 웹사이트 및/또는 다른 이용자들에 대한
근거없는 평가를 하지 않기로 한다.
이러한 규칙에 반하는 것으로 간주되는 모든 콘텐츠는, 베스티에르 콜렉티브 또는 다른 이용자들
을 통하였는지를 불문하고, 해당 콘텐츠를 공개한 이용자에 의해 생성된 것으로 간주된다.
1. 이 웹사이트의 가용성
베스티에르 콜렉티브는 이 웹사이트의 가용성이나 접근성에 관한 확약을 하지 아니하며, 이 웹사
이트에 대한 이용자의 액세스, 이 웹사이트상에 보여지는 콘텐츠, 또는 베스티에르 콜렉티브가 제
공하는 서비스가 중단없이·명시된 기한 동안·오류 없이 제공될 것임을 보장하지 아니한다.
불가항력을 전제로 하여, 베스티에르 콜렉티브는 이 웹사이트가 1주 7일, 1일 24시간 동안 액세스
가능하도록 유지하기 위해 노력한다. 다만, 기술적 유지보수 및/또는 보안상의 이유로, 베스티에르
콜렉티브는 임시적으로 고지 없이 이 웹사이트에 대한 액세스를 전부 또는 부분적으로 정지할 수
있다. 이용자가 본 약관에 동의한 경우, 이용자는 이러한 기술적 이유로 인한 중단을 인정한 것으
로 간주된다.
베스티에르 콜렉티브는 기술적·상업적 사유 등으로 인해 이 웹사이트를 변경할 수 있다. 이러한
변경이 서비스 제공 조건에 중대하게 및/또는 부정적으로 영향을 미치지 않는 경우, 이용자들은 해
당 변경에 대해 고지받을 수 있으나, 이용자들의 승인이 요구되지 아니한다.
2. 준거법 및 분쟁해결
본 약관은 프랑스법에 의해 규율된다. 국제물품매매계약에 관한 유엔협약은 본 약관에 적용되지
아니한다.
당사자들이 분쟁을 우호적으로 해결하지 못하는 경우, 베스티에르 콜렉티브 및 이용자는 해당 분
쟁을 프랑스 법원의 관할로 하는 데 동의한다. 본 약관의 어떠한 내용도 EU에 거주하는 소비자로
서 거주국의 현지법의 강행규정에 의존할 이용자의 권리에 영향을 미치지 아니한다.
본 조의 조건으로 인해 소비자로부터 자신이 거주하거나 소재하는 국가에서 소송을 제기하거나
소송에서 자신을 방어할 권리를 박탈하거나 거주국의 관련 규칙 및 규정에 명시된 소비자를 위한
보호조치를 박탈하지 아니한다.


# 구매자용 일반약관

해당 조건들은 상품을 구매하기 위해 당사 서비스를 이용하는 이용자들에게 적용됩니다.


“구매자”용 일반약관

2020년 7월 21일 

서문 

본 일반약관(“본 약관”)은 이 웹사이트를 이용하여 상품을 구매하는 이용자들에게 적용됩니다.

베스티에르  콜렉티브는  프랑스에서  설립된  공개유한회사로  255  boulevard  Pereire,  75017  Paris, France에 등록된 주소를 두고 있으며 프랑스 파리에서 517 465 225호로 등록되어 있습니다. 베스티 에르 콜렉티브는 htt[p://www.vestiairecollective.com 웹사이트](https://es.vestiairecollective.com/documents/cgu-mangopay-es.pdf) 및 베스티에르 콜렉티브 스마트폰 애 플리케이션(“이 웹사이트”)에 대한 모든 권리를 소유합니다. 

베스티에르 콜렉티브는 이 웹사이트를 통해 베스티에르 콜렉티브가 운영· 관리하는 다양한 서비 스를 이 웹사이트에서 제공하고 있습니다. 이 서비스를 통해 웹사이트 이용자들(“이용자들”)은 중 고 패션 상품(“상품”)을 거래할 수 있습니다. 이러한 서비스는 이 웹사이트에서 직접 이용할 수 있 습니다. 베스티에르 콜렉티브는 예외적인 상황에서 자체적으로 직접 상품을 판매할 수 있으며, 이 경우 해당 상품은 이 웹사이트에서 베스티에르 콜렉티브가 판매하는 것으로 표시됩니다.  

본 약관은 베스티에르 콜렉티브와 이용자가 공동으로 명시적으로 승인하지 않은 기타 일반약관이 나 특별약관에 우선합니다.

본 약관은 (해당되는 경우) [프리미엄 서비스 가입약관, MangoPay](https://www.vestiairecollective.com/documents/cgu-premium-en.pdf) [서비스 및 전자화폐 이용약관과 소개에 관한 규칙에 의해](https://www.vestiairecollective.com/documents/cgu-sponsorship-en.pdf) 보충될 수 있습니다. 이러한 추가 계약조건이 적용되는 경우, 해당 추가 계약조건은 정당하게 본 약관에 편입된 것으로 간주됩니다. 또한 베스티에르 콜렉티브의 개인정 [보보호방침 및 쿠키를 ](https://www.vestiairecollective.com/privacy-policy/)숙독하시기 바랍니다.  

이 웹사이트에서 이루어지는 구매에 적용되는 약관 ![](Aspose.Words.67530dd0-4666-4ea0-9c17-12cc801f4c51.001.png)

1. 베스티에르 콜렉티브의 역할 및 책임 

이 웹사이트에서 판매가 제안된 특정 상품에 대해 달리 명시된 경우를 제외하고, 이용자들은 베스 티에르 콜렉티브의 역할이 이용자들 간의 중개 플랫폼 역할을 하는 것으로 제한됨을 확인한다. 이 를 위해, 특정 상황을 제외하고, 베스티에르 콜렉티브는 상품의 리셀러로 행위하지 아니하며 어느 시점에도 상품의 소유자가 되지 아니한다. 각 이용자는 언제라도 자신을 위해 행위하며, 베스티에 르 콜렉티브의 대리인 또는 대표자로 행위하지 아니한다. 베스티에르 콜렉티브는 구매자와 판매 자 간 판매계약의 당사자가 아니며, 이에 해당 계약 또는 그 결과에 대한 책임을 부인한다. 

베스티에르 콜렉티브가 잠재적으로 수행하는 품질관리는 단순히 판매자가 판매하는 상품이 해당 판매자가 작성한 상품페이지의 설명과 일치하는지에 관한 것이다. 베스티에르 콜렉티브는 판매자 의 상품페이지에 있는 상품 또는 상품 설명이 구매자의 기대를 충족하는지 여부를 확인하지 아니 한다. 따라서, 베스티에르 콜렉티브는 구매자가 상품의 사용에 있어 미적인 관점이나 실용적 관점 에서 상품에 만족할 것임을 보증하지 아니한다. 베스티에르 콜렉티브가 배송을 주선하고 그 협력 업체들이 이를 이행하는 것이 베스티에르 콜렉티브가 판매자와 구매자 간 계약의 당사자임을 의 미하지 아니한다. 

베스티에르 콜렉티브에 책임을 물을 수 있는 상품의 배송지연 또는 배송불이행에 대한 불만사항 을 제외하고, 온라인에 광고된 상품 및 상품페이지에 관한 이용자의 의견, 및/또는 판매자의 상품 발송 및 배송(이러한 배송이 상품의 판매, 교환 또는 반품의 일환인지의 여부를 불문함)에 대한 답 변은 판매자의 소관이며, 이러한 종류의 클레임 또는 불만은 이를 처리할 단독 책임을 지는 판매자 에게 전달된다. 

2. 구매자의 주문 

상품페이지에는 판매를 위해 제공되는 상품이 비전문 판매자 또는 전문 판매자(경우에 따라, 베스 티에르 콜렉티브 본인일 수 있음)에 의해 소유 및 판매되는지 여부가 명시되어야 한다. 판매자들은 자신들의 원어로 상품에 관한 정보를 제공한다. 상품페이지의 원어가 그 번역본과 모순되거나 충 돌하는 경우, 상품페이지의 원어가 우선한다. 베스티에르 콜렉티브는 정보 제공 목적으로만 제공 되는 번역본에 대한 모든 책임을 부인한다. 

이 웹사이트에서 판매되는 상품의 가격은 세금을 포함한 가격이나, 별도로 표시되는 추가 비용(인 증비용, 운송비용 및 관세)은 제외된다. 그럼에도 불구하고, 일부 국가에서 시행되고 있는 특정 운 송세 및 관세는 이러한 추가 비용과 함께 청구될 수 있으며, 본건 주문의 결제 과정에서 반드시 언 급되어야 한다. 제반 비용은 모든 경우에 구매자가 승인하기 전에 본건 주문의 요약에 명시되어야 한다. 

구매자의 주문 확인은 선행조건(즉, 베스티에르 콜렉티브가 상품을 수령하고 컴플라이언스 확인 의 긍정적인 결과(컴플라이언스 확인을 베스티에르 콜렉티브가 수행한 경우)을 전제로 계약에 서 명하는 것에 해당한다. 베스티에르 콜렉티브가 상품을 수령하지 않거나 품질관리확인 결과가 부 정적인 경우, 베스티에르 콜렉티브는 해당 주문을 취소하고 구매자에게 환불할 권리가 있다.  

위의 경우를 제외하고, 베스티에르 콜렉티브가 상품의 판매자로 행위하거나 판매자가 구매자에 게 직접 상품을 배송하는 경우, 본건 주문 시 판매계약에 서명한 것으로 간주된다. 

구매자가 주문한 상품이 여하한 사유로 제공될 수 없는 경우, 본건 주문 확인 후 베스티에르 콜렉 티브는 적시에 구매자에게 연락하여 본건 주문 확인일로부터 30일 내에 본건 주문의 취소 및 환불 (결제가 이미 이루어진 경우)을 제안한다. 

베스티에르 콜렉티브는 이전의 주문에 대한 결제 또는 판매가격에 명백한 오류가 있는 상품과 관 련하여 다툼이 있는 구매자의 주문을 거절할 권리가 있다. 이 경우, 베스티에르 콜렉티브가 취한 조치에 대해 구매자에게 이메일로 통보하며, 그 후 구매자가 본건 주문의 대금을 이미 결제한 경우 해당 가격을 자동으로 환불한다. 

3. “오퍼하기” 기능 

“오퍼하기” 기능을 통해 구매자는 판매자에게 오퍼를 보내 상품의 가격을 비밀리에 협상할 수 있 으며, 판매자는 이를 수락 또는 거부하거나 구매자에게 카운터오퍼를 할 수 있다. 

오퍼의 일환으로 제안된 가격은 상품 가격의 70% 이상이어야 하나 상품 가격을 초과할 수 없다. 

4. 인증비용 

베스티에르 콜렉티브가 부과한 인증비용은 각 본건 거래에 대해 구매자가 결제한 금액의 합계와 동일한 금액이다. 인증비용은 본건 주문 확인 전에 명시되어야 한다. 

판매자가 상품을 직접 발송한 경우 인증비용은  청구되지 아니한다. 

5. 배송 

5.1. 배송 옵션

이 옵션이 가능한 경우, 상품은 베스티에르 콜렉티브가 발송하거나 또는 판매자가 직접 발송할 수 있다. 

판매자가 상품을 직접 발송하는 옵션은 판매자가 “소비자 정보[” 조항에 명시된](https://fr.vestiairecollective.com/informations-consommateur.shtml) “트러스티드 벤더 (Trusted Vendor)”의 지위를 취득한 경우에만 가능하다.  

2020년 3월 18일부터 무기한으로, 상품은 판매자의 지위에 관계없이 모두 판매자에 의해 직접 발 송된다. 

그 이후 직접 배송을 선택할 지는 구매자가 결정한다. 직접 배송의 경우, 상품은 베스티에르 콜렉 티브를 통해 운송되지 않으므로, 베스티에르 콜렉티브는 상품의 배송에 대한 아무런 책임을 지지 아니한다. 

5.2. 배송 일정

베스티에르 콜렉티브가 직접 이 웹사이트에서 상품을 판매하는 경우, 구매자의 본건 주문 발주 시 구매자에게 배송 날짜를 명시해야 한다. 

베스티에르 콜렉티브가 판매자를 대리하여 단순히 중개자로 행위하는 경우, 구매자에 대한 상품 의 배송일은 판매자가 발송한 상품을 베스티에르 콜렉티브가 수령한 날짜에 따라 달라진다. 따라 서, 베스티에르 콜렉티브는 확정된 배송일을 약속할 수 없으나, 상품 발송일은 구매자의 본건 주문 확인일로부터 최대 30일로 한다. 

판매자가 직접 상품을 발송하는 경우, 이 옵션이 가능한 한, 판매자는 배송 일정을 명시해야 한다. 

구매자가 “즉시 배송가능(ready to go)”으로 표시된 상품을 구매하는 경우, 당사 팀은 24 영업시간 내에 주문 제품을 발송하며, 여기에 운송인의 배송 기간을 추가해야 한다. 

5.3. 배송 및 통관 비용 

본건 주문은 베스티에르 콜렉티브가 승인한 운송인에 의해 구매자에게 배송되어야 한다. 

운송비용이 달리 적용되는 예외적인 상품 또는 주문의 경우(이에 대해서는 주문 당시 구매자에게 적절히 통보해야 함)를 제외하고, 운송비용은 주문된 상품의 가격을 기준으로 산정되며, 본건 주문 이 배송되는 국가 별로 다르다.  

운송비용은 운송인이 부과한 요율에 따라 변경될 수 있으며, 본건 주문 시 명시되어야 한다. 본건 주문에 적용되는 운송비용은 본건 주문 승인 직전에 명시된 비용으로 한다. 

관세는 구매자가 부담한다. 본건 주문이 완료되는 즉시, 관세(배송 국가별로 상이한 금액이 적용됨) 는 상품 가격에 추가되며, 구매자는 상품 수령 시 어떤 금액도 지급할 필요가 없다.  

6. 상품 배송 불가에 따른 결과

6.1. 베스티에르 콜렉티브를 통해 발송된 경우 

구매자가 제공한 주소가 부정확하거나 구매자의 인수거절로 소포가 반송되는 경우 등 상품을 판 매자에게 배송할 수 없는 경우, 해당 상품의 구매자에게 이메일을 발송하고 전화를 해야 한다. 회 신이 없는 경우, 해당 상품은 베스티에르 콜렉티브의 후속 이메일을 발송한 시점부터 6개월 동안 구매자의 위험 및 비용(보관 및 처리 비용 포함) 부담으로 구매자의 처분에 따라 보관된다.  

구매자가 해당 상품의 회수를 원하는 경우, 다음 주소로 수령확인서가 포함된 등기우편 서신으로 베스티에르  콜렉티브에  요청해야  한다:  Vestiaire  Collective,  255  boulevard  Pereire,  75017  Paris, France. 

상기 언급된 6개월의 기간 내에 베스티에르 콜렉티브로부터 상품이 회수되지 않는 경우, 베스티에 르 콜렉티브는 구매자가 회수하지 않은 해당 상품의 소유자가 된다. 구매자에게 최종적으로 연락 을 시도하여 8일 이내에 회신이 없는 경우, 해당 상품은 파기되거나, 기부가능한 상태인 경우 자선 단체에 기부된다.  

6.2. 판매자가 발송한 경우 

구매자가 제공한 주소가 부정확하거나 구매자의 인수거절로 소포가 반송된 경우 등 구매자에게 상품을 배송할 수 없는 경우, 해당 소포는 판매자가 선정한 운송인의 조건에 따라 판매자에게 반환 된다.  

7. 상품 소유권 및 위험의 이전 

상품은 판매자의 자산으로 유지되거나, 베스티에르 콜렉티브가 상품의 판매자로 행위하는 경우 베스티에르 콜렉티브가 구매자로부터 주문의 가격(자본 요소 및 부수적 요소(세금, 인증비용, 운 송비용 및 적용가능한 모든 기타 비용) 포함)을 전액 지급받을 때까지 베스티에르 콜렉티브의 자 산으로 유지된다.  

구매자에 대한 상품의 분실이나 손상 위험의 이전은 구매자나 구매자가 자신을 대리하도록 위임 한 제3자가 상품을 수령하는 때에 이루어진다. 이에 따라, 구매자는 상품 수령 시점부터 상품에 발 생한 손상에 관한 위험을 부담한다.  

8. 주문 수령 및 확인 

구매자는 운송인이 제공한 양식에 서명하기 전에 수령 시 상품 포장의 외관 상태를 반드시 확인해 야 한다(또는 상품의 수령인으로 하여금 구매자를 대신하여 확인하도록 위임해야 함).  

눈에 보이는 이상(손상, 분실 상품, 손상된 소포나 상품 등)이 있는 경우, 구매자나 그 대리인은 배 송전표에 구체적 내용(분실 및/또는 손상된 소포 및/또는 상품의 수량 표시 및 손상에 관한 구체적 설명(포장이 개봉되거나 파손되어 있는 경우, 상품이 손상되거나 분실된 경우 등))을 필수적으로 기재해야 한다. 구매자는 반드시 모든 요소들을 해당 요소들이 구매자에 인도된 상태로(즉, 모든 부속품을 포함하여 상품과 함께 수령한 물품을 원래 상태 및 밀봉된 상품의 형태로) 유지하여야 한 다.  

구매자는 배송전표의 사본을 보관하고, 해당 사본을 이상상태를 확인하기 위해 상품 수령 시로부 터 72시간 이내에 베스티에르 콜렉티브에 발송되는 이메일에 첨부해야 한다.  

해당되는 경우, 베스티에르 콜렉티브에 대한 손상된 상품이나 상품의 반품은 아래 제13조에 명시 된 반품 관련 조건에 따라 진행되어야 한다.  

상품을 판매자가 직접 발송한 경우, (위조품의 경우를 제외하고) 손상된 상품을 판매자에게 반품 한다.  

본 조의 내용은 특정 조건에 따라 아래 제10조에 명시된 법정 보장에 따른 혜택을 받을 수 있는 구 매자의 권리를 해하지 아니한다.  

9. 결제 조건  

구매자는 가격, 인증비용, 운송비용 및 기타 비용을 베스티에르 콜렉티브의 보안결제시스템을 통 해, 은행 카드, VISA 카드, Mastercard, American Express 카드, Cofinoga 카드로, 또는 Paypal 시스템 이나 LEETCHICORP에 개설된 이용자의 전자지갑(MangoP[ay 서비스 및 전자화폐 이용약관)을 통 ](https://www.vestiairecollective.com/documents/cgu-mangopay-en.pdf)해 지급할 수 있다.  

PayPal을 이용하여 결제하기 위해서는, 구매자는 반드시 PayPal 계정을 보유해야 하며, 구매자에게 PayPal 이용약관([여기를 클릭하여 표](https://www.paypal.com/uk/webapps/mpp/ua/legalhub-full?locale.x=en_GB)출되는 페이지에서 해당 국가를 선택하면, PayPal 웹사이트에 서 열람할 수 있음)이 적용된다.  

PayPal 이용약관은 국가별로 상이할 수 있다.  

베스티에르 콜렉티브는 구매자들이 결제를 위해 구매자들의 VISA 및 Mastercard의 카드 상세정보 를 영국 파운드 및 미국 달러화로, 또한 구매자들의 American Express 카드 상세정보를 유로, 영국 파운드 및 미국 달러화로 등록할 수 있도록 한다. 이를 위하여, 구매자는 “본인은 해당 판매자에게 추가 주문을 발주하는 때에 본인의 금융 정보를 입력하지 않을 수 있도록 Ogone가 본인의 금융정 보를 저장하는 것을 승인합니다” 박스를 체크해야 한다. 결제 내역은 베스티에르 콜렉티브가 아닌 베스티에르 콜렉티브의 결제대행사인 Ogone에서 보관한다. 구매자는 자신이 어느 시점에 저장한 카드를 나중에 삭제할 수 있고, “내 계정(My Account)” 페이지를 방문하여 구매자의 비밀번호 재설 정시 구매자의 은행계좌 상세정보가 자동 삭제되게 하는 보안 옵션을 선택할 수 있다. 이와 관련하

여, Ogone (INGENICO E-COMMERCE SOLUTIONS) SASU(자본금: 40,000유로; 등록된 주소: 28 boulevard de Grenelle, 75015 Paris, France; 등록지: 프랑스 파리, 등록번호 435 236 898호)는 이용자 결제정보의 개인정보 컨트롤러 자격으로 행위한다.    

구매자가 결제한 금원을 수취 및 캐싱(cashing)한 경우, 베스티에르 콜렉티브는 해당 사실을 이메 일로 구매자 및 판매자에게 통지한다.  

다만, 제품 발송 전에 본건 주문을 확인하고, 필요한 경우 추가 증빙을 요청하기 위해, 베스티에르 콜렉티브의 파트너사인 FIA-NET S.A 및/또는 베스티에르 콜렉티브의 “위험” 관리 부서에서 전화, 이메일 또는 우편으로 구매자에게 확인을 실시할 수 있다.  

이러한 확인에 따라, 구매자가 제공한 요소들에 고의적으로 오류가 있고/있거나 해당 요소들이 사 기인 경우, 구매자의 본건 주문을 거절할 수 있다. 이 경우, 구매자에게 베스티에르 콜렉티브가 취 한 조치에 대해 이메일로 통지해야 하며, 이미 결제가 진행된 경우 베스티에르 콜렉티브는 구매자 가 지급한 금액을 자동으로 환불한다.  

구매자의 지리적 위치에 따라, 아래 명시된 특정 조건을 전제로 하여, 베스티에르 콜렉티브는 구매 자에게  (해당되는  경우에  따라)  (i)  베스티에르  콜렉티브의  파트너사인  “BNP  Paribas  Personal Finance” 또는 (ii) 베스티에르 콜렉티브가 관리하는, 3회 할부지급을 제안할 수 있다. 이러한 할부 조건은 본건 주문 발주 시에 공개되어야 한다.  

“carte CB” 카드로 3회 할부지급 옵션을 사용하기 위하여, 구매자는 프랑스 본토나 모나코에 거주 해야 하고 법정 성인이어야 한다. 결제는 CB Visa 또는 Mastercard를 사용하여 진행되며, 결제에 사 용된 신용카드의 만료일은 3회차 할부지급일보다 나중이어야 한다. 이 서비스는 베스티에르 콜렉 티브의 파트너사인 “BNP Paribas Personal Finance”(공개유한회사, 자본금: 475 411 827유로, 등록 지: 프랑스 파리, 등록번호 542 097 902호, 등록된 주소: 1, boulevard Haussmann, 75318 Paris Cedex 09, France – ORIAS 번호: 07 023 128 – 전화번호: +33 [0]5 56 55 56 00)에서 제공한다.  

구매자가 구매자의 계정에 등록된 전자지갑을 보유하고 있는 경우, 구매자는 이 웹사이트에서 발 주된 주문을 결제하기 위해 전자지갑을 사용할 수 있으며, 전자지갑에 예치된 잔액이 부족한 경우 잔액을 Carte Bleue 은행카드로 결제할 수 있다. 

10. 법정 보장 

특정 조건에 따라, 구매자는 컴플라이언스 관련 법정 보장 및 숨겨진 결함에 관한 법정 보장에 따 른 혜택을 받을 수 있다. 구매자는 상품의 판매자를 상대로 구매자의 법정 보장을 주장해야 한다.  

컴플라이언스 관련 법정 보장의 경우: 전문 판매자 또는 베스티에르 콜렉티브로부터 상품을 구매 하는 비사업자 구매자는 상품 배송 시점으로부터 2년 동안 상품에 영향을 미치는 컴플라이언스 관 련 결함에 대한 조치를 취할 수 있다. 중고 상품의 경우, 구매자는 상품 배송일로부터 6개월 동안 상품의 컴플라이언스 관련 결함의 존재에 관한 증거를 제출하여야 할 의무로부터 면제된다. 구매 자는 상품 수리 요청 또는 환불 중 택일할 수 있다. 

컴플라이언스 관련 법정 보장의 혜택은 전문 판매자로부터 상품을 구매한 사인(私人)에 해당하는 구매자에게만 적용된다.  

숨겨진 결함에 대한 법정 보장의 경우: 해당 법정 보장에 따라, 구매자는 거래 취소와 판매가격 인 하 중 택일할 수 있다. 구매자는 거래 시에 숨겨진 결함이 존재하였음을 입증해야 한다. 

11. 클레임 및 반품

11.1 상품 미도착 또는 배송지연 

구매자가 주문일로부터 30일 내에 상품을 수령하지 못하거나, 또는 베스티에르 콜렉티브가 이 웹 사이트상에서 직접 상품을 판매하는 경우 구매자가 발주 당시 정한 배송일에 상품을 수령하지 못 한 경우, 구매자는 다음 주소로 수령확인증이 동봉된 등기우편으로 발송된 서신을 통해 본건 거래 를 취소할 수 있다: Vestiaire Collective, 255 boulevard Pereire, 75017 Paris, France. 다만, 이는 구매자 가 우선 합리적인 기한 내에 해당 상황을 개선하기 위해 동일한 방법으로 베스티에르 콜렉티브에 통지하고, 이러한 추가 기간 내에 배송이 이루어지지 아니하였을 것을 전제로 한다.  

베스티에르 콜렉티브는 본건 거래의 취소를 통지하는 내용으로 수령확인증이 동봉된 등기우편으 로 송부된 서신을 수령한 날로부터 14일 내에 구매자에게 환불해야 한다.  

구매자 본건 거래를 이미 취소하였음에도 불구하고 상품을 수령하는 경우, 구매자는 상품을 베스 티에르 콜렉티브로 또는 (해당 상품을 판매자가 직접 발송한 경우) 판매자에게 반품하여야 하며, 베스티에르 콜렉티브는 베스티에르 콜렉티브 또는 판매자가 상품을 원래의 상태로 완전하게 수령 한 날로부터 14일 내에 반품된 상품의 가격, 인증비용, 운송비용(주문을 전부 반품한 경우) 및 베스 티에르 콜렉티브로의 반품비용을 환불하기로 한다. 이러한 반품은 아래 제13조의 조건에 따라 진 행된다. 

취소의 경우, 구매자에 대한 환불은 구매자가 자신의 본건 주문을 결제하기 위해 사용한 결제방식 으로 현금으로 이루어진다. 다만, 각 경우, 이는 베스티에르 콜렉티브가 주문된 상품의 전부 또는 일부 미도착으로 인한 취소 요청이나 환불 요청이 사기에 의한 것이라고 의심하지 않을 것을 전제 로 한다. 부분 취소의 경우, 주문 중 취소된 부분에 대해서만 상기 조건에 따라 환불이 이루어진다.  

11.2. 베스티에르 콜렉티브가 수행한 품질관리 중 불일치를 발견하는 경우 

베스티에르 콜렉티브에 의해 발견된 상품과 상품페이지의 불일치에 따른 결과는 해당 불일치의 유형에 달라진다. 

구매자가 제공한 상품페이지의 설명과 불일치하는 상품, 위조품 또는 판매가 금지되는 상품의 경 우, 베스티에르 콜렉티브는 판매를 취소하고 구매자에게 환불한다. 

상품이 설명과 부분적으로만 일치하는 경우, 구매자의 재량에 따라 베스티에르 콜렉티브는 (i) 판 매자와 가격 인하를 협상하거나, (ii) 판매를 취소하고 구매자에게 환불한다. 구매자 및 판매자가 가격 인하에 합의하는 경우, 가격 인하는 (해당되는 경우에 따라) 결제카드 또는 구매자의 PayPal 계정으로 재입금되는 형식으로 이루어질 수 있다. 

구매자가 본건 주문을 취소하는 경우, 처음에 결제에 사용된 은행카드에 입금하거나 PayPal 계정 이나 전자지갑(구매자가 이를 보유하고 있는 경우)으로 지급되어 구매자에 대한 환불은 현금으로 이루어진다. 부분 취소의 경우, 취소되는 부분의 본건 주문 만이 상기 조건에 따라 환불된다. 

11.3. 구매자가 상품 수령 후 불일치를 발견하는 경우 

(i) 비전문 판매자로부터 구매한 상품의 경우: 

상품이 베스티에르 콜렉티브를 통해 발송된 경우: 

   구매자가 상품이 상품페이지의 설명과 불일치함을 발견하는 경우, 구매자는 상품의 수령 일로부터 14일 내에 이메일을 통해 베스티에르 콜렉티브에 문의해야 한다. 

   구매자는 상품이 상품페이지와 일치하지 않는 방식과 그 정도를 설명하여야 하며, 주장이 입증될 수 있도록 사진을 제공해야 한다. 

   상품이 상품페이지와 일치하지 않는다는 주장이 구매자의 설명 및 사진을 기초로 일견 타 당한 것으로 보이는 경우, 베스티에르 콜렉티브는 구매자가 상품을 반송하도록 승인한다. 

   상품 수령 시, 베스티에르 콜렉티브는 해당 상품이 상품페이지와 실제로 일치하지 않는지 여부를 결정하기 위해 이를 검사한다. 불일치함이 확인되는 경우, 베스티에르 콜렉티브는 구매자에게 환불한다. 환불은 구매자의 재량에 따라 처음에 결제에 사용된 (해당되는 경우 에 따라) 은행카드나 구매자의 PayPal 계정 또는 구매자의 전자지갑(구매자가 이를 보유하 고 있는 경우)으로 입금하여 이루어진다. 

   상품페이지와 불일치함으로 인해 구매자가 반환한 모든 상품은 베스티에르 콜렉티브가 발 송 시 처음에 상품에 부착한 봉인 양식(라벨)과 함께 반환되어야 한다. 

   구매자가 위조품이나 판매가 금지된 상품을 수령하는 경우, 구매자는 본인 측의 사기의 경 우를 제외하고 해당 상품을 베스티에르 콜렉티브에 반품하고 환불을 받을 수 있다. 

   구매자가 판매자가 직접 배송하는 상품을 선택한 경우: 

   구매자가 상품이 상품페이지의 설명과 불일치함을 발견하는 경우, 구매자는 상품의 수령 일로부터 72시간 내에 이메일을 통해 베스티에르 콜렉티브에 문의해야 한다. 

   구매자는 상품이 상품페이지와 일치하지 않는 정도를 설명하여야 하며, 주장이 입증될 수 있도록 사진을 제공해야 한다. 

   상품이 상품페이지와 일치하지 않는다는 주장이 구매자의 설명 및 사진을 기초로 일견 타 당한 것으로 보이는 경우, 베스티에르 콜렉티브는 구매자가 판매자에게 상품을 반송하도 록 승인한다. 베스티에르 콜렉티브는 판매자가 상품을 수령함을 확인하는 후에 구매자에 게 환불한다. 최종 환불은 구매자의 재량에 따라 처음에 결제에 사용된 (해당되는 경우에 따라) 은행카드나 구매자의 PayPal 계정 또는 구매자의 전자지갑(구매자가 이를 보유하고 있는 경우)으로 입금하여 이루어진다. 

(ii) 전문 판매자로부터 구매한 상품의 경우: 

구매자가 상품이 상품페이지의 설명과 일치하지 아니함을 발견하는 경우, 구매자는 제10 조에 상세히 기재된 법정 보장에 따라 베스티에르 콜렉티브를 통해 전문 판매자에게 클레 임을 제기할 권리를 가진다. 

상품페이지의 설명과 일치하지 않는 상품에 대하여 불만을 제기하는 경우, 구매자는 아래 제13조에 따라 상품을 반환해야 한다. 

전문 판매자는 구매자가 해당 상품페이지의 설명과 일치하지 않거나 전문 판매자의 법적 의무를 충족하지 않음으로 인해 상품을 반환하는 경우, 전문 판매자가 상기 조건의 적용을 거부할 수 없으며, 합리적인 기간 내에 적절한 조치를 취하여야 함을 확인하고 이에 동의한 다. 

구매자가 위조품이나 판매가 금지된 상품을 수령하였다고 판단하는 경우, 구매자는 상품 수령일 로부터 72시간 내에 이메일을 통해 베스티에르 콜렉티브에 알려야 하며, 본인 측의 사기인 경우를 제외하고 환불을 받기 위해 베스티에르 콜렉티브에 상품을 반품할 수 있다. 

본 조의 조항은 베스티에르 콜렉티브로 하여금 판매자 및 구매자 간의 매매의 당사자가 되도록 하 지 아니한다. 해당 상품페이지 설명과의 불일치, 위조품 또는 판매가 금지된 상품임을 이유로 구매 자가 반품하는 상품과 관련하여, 판매자가 구매자에게 환불하거나 기타 보상을 구매자에게 지급 할 의무를 준수하지 않은 경우, 베스티에르 콜렉티브는 사업자 또는 비전문 판매자의 본 제11조에 따른 자신들의 의무 준수 불이행에 대한 책임을 부인한다. 

12. 전문 판매자로부터 구매 시 철회권 

유럽경제지역에 소재한 비사업자 구매자가 전문 판매자(베스티에르 콜렉티브가 이 웹사이트에서 직접 상품을 판매하는 경우, 베스티에르 콜렉티브 포함)으로부터 상품을 구매하는 경우, 비사업자 구매자는 상품 수령 후 14일의 기간 내에 전문 판매자에게 연락하여 철회권을 행사할 수 있다. 이 기간 동안, 구매자는 정당한 이유를 제시하거나 위약금을 지급할 필요 없이 전문 판매자에게 연락 하여 본건 거래를 철회할 권리를 행사할 수 있다. 구매자는 상품 수령 이전에도 철회권을 행사할 수 있다. 

구매자가 위 기간 내에 철회권을 행사하는 경우, 구매자는 본 약관에 첨부된 철회 양식을 작성하여 야 한다. 또한, 구매자는 위 기간 내에 기타 모든 방법으로 철회권을 행사하고자 하는 자신의 의사 에 대해 명확하고 분명하게 베스티에르 콜렉티브에 알릴 수 있다. 

구매자는 아래 제13조의 조건에 따라 매매를 철회할 자신의 결정을 통지한 날로부터 최대 14일 내 에 베스티에르 콜렉티브나 판매자(판매자가 직접 상품을 발송한 경우)에게 상품을 반환해야 한다. 

이에 따라, 베스티에르 콜렉티브는 베스티에르 콜렉티브가 상품을 수령한 후 14일 내에 구매자가 지급하였을 모든 금액, 즉 가격 및 표준 운송비용(다만, 구매자가 표준배송이 아닌 더 비싼 배송방 식을 선택하여 발생한 추가 운송비용은 구매자에게 환불되지 아니함) 및 인증비용을 (구매자가 본 건 주문 결제에 사용한 동일한 결제방식을 이용하여) 구매자에게 환불한다. 

판매자가 구매자에게 상품을 직접 발송한 경우를 제외하고, 구매자는 구매자의 비용으로 상품을 베스티에르 콜렉티브에게 반품해야 한다. 베스티에르 콜렉티브가 상기 14일 내에 철회권이 행사 된 상품을 수령하지 않은 경우, 베스티에르 콜렉티브는 구매자의 비용으로 구매자로부터 해당 상 품이 회수되도록 주선할 수 있다. 

위생용 포장이 상품 수령 후 훼손된 상품(귀걸이 및 기타 피어싱 장신구, 속옷 또는 수영복 등)에 대해서는 철회권이 행사될 수 없다. 

구매자가 비전문 판매자로부터 상품을 구매하는 경우, 구매자는 매매를 철회할 권리를 갖지 아니 한다. 다만, 호의의 표시로서 상품을 수령한 후 14일 내에 베스티에르 콜렉티브는 구매한 상품을 갖고 싶어하지 않는 구매자가 이를 이 웹사이트에서 재판매할 수 있도록 허용한다. 판매용으로 게 시된 상품이 판매되는 경우, 베스티에르 콜렉티브는 수수료를 받지 아니한다. 다만, 베스티에르 콜 렉티브는 이 웹사이트에 판매용으로 게시되는 물품의 발송, 포장 및 취급비용을 충당하기 위해 아 래 명시된 비용을 구매자에게 청구한다. 이러한 과정을 촉진하기 위해, 베스티에르 콜렉티브는 직 접 구매자에게 환불하고 구매자를 대신하여 판매자로부터 환불된 금액을 회수할 자격을 가진다. 

| 통화  | 가격         | 재판매 비용 |
| ----- | ------------ | ------------ |
| 파운드 | 1 – 135     | 9            |
| 파운드 | 136 – 450   | 23           |
| 파운드 | 451 - 900   | 45           |
| 파운드 | >900        | 90           |



13.반품에 적용되는 조건
  
13.1.모든 반품의 경우

상품을 반품하고자 하는 이용자는 http://fa[q.vestiairecollective.com에서 이용가](http://faq.vestiairecollective.com)능한 FAQ 문의양식 을 이용하여 요청하거나 베스티에르 콜렉티브 상담전화 +33 [0]9 70 25 37 37로 연락할 수 있다 

반품은 베스티에르 콜렉티브의 파트너인 운송인을 통해 이루어진다. 

13.2. 판매자에 대한 반품 

상품은 판매자가 명시한 주소로 반품되어야 한다. 배송 중 상품의 분실이나 손상이 발생하는 경우, 베스티에르 콜렉티브는 그에 대한 책임을 부인한다. 

13.3. 베스티에르 콜렉티브에 대한 반품 

상품은 다음 주소로 베스티에르 콜렉티브에 반품되어야 한다: Vestiaire Collective, 255 boulevard Pereire, 75017 Paris, France. 배송 중 상품의 분실이나 손상이 발생하는 경우, 베스티에르 콜렉티브 는 그에 대한 책임을 부인한다. 

배송지연으로 인해 최초 거래가 취소됨에 따라 반품되는 상품은 수령확인증이 동봉된 등기 우편 으로 반품되어야 한다. 

베스티에르 콜렉티브는 구매자가 상품에 대해 특별한 주의를 기울여야 한다는 사실을 유의하도 록 한다. 베스티에르 콜렉티브는 손상되거나 불완전한 상품의 반품을 거부하거나 상품에 발생한 손상(이러한 손상이 구매자에게 배송된 후 발생한 경우)에 대한 보상으로 지급되어야 하는 금액을 차감한 후 구매자에게 환불할 자격을 가진다. 또한, 이러한 상품의 성격, 특징 및 적절한 작동을 확 인하기 위해 필요한 바를 제외한 기타 취급, 고의적 손상, 구매자나 제3자 측의 사고나 과실, 그 목 적에 부합하지 않은 상품의 사용, 제조업자의 가이드라인이나 베스티에르 콜렉티브의 가이드라 인 미준수 또는 베스티에르 콜렉티브의 사전 동의 없이 수행된 변경이나 수리로 인해 상품의 가치 가 하락하는 경우 구매자는 그에 대한 책임을 부담한다. 

상품의 가격에 비해 수리나 클리닝 비용이 상대적으로 높은 상태로 반품되는 상품은 환불되지 아 니하며, 그 후 최대 6개월 동안 구매자의 위험으로 구매자의 처분에 따라 보관된다. 

베스티에르 콜렉티브가 상품을 수령한 후 6개월 내에 구매자로부터 상품의 점유를 회복하기 위한 요청을 받지 않은 경우, 베스티에르 콜렉티브는 회수되지 않은 (해당되는 경우에 따라) 환불불가 하거나 반품된 상품의 소유자가 된다. 해당 상품은 파기되거나 기부가능한 상태인 경우 자선단체 에 기부된다. 

구매자가 제12조에 명시된 매매의 철회기간 내에 본건 주문 취소 시, 본건 주문이 구매바우처를 사 용하여 전부 또는 일부 지급된 경우, 해당 본건 주문에 사용된 구매바우처는 구매자의 계좌로 재입 금된다. 

기타 조항

14. 기간 및 효력 

이용자들은 이 웹사이트 액세스 시 또는 이 웹사이트에 등록 시 본 약관을 승인한 시점부터 자신들 의 계정이 취소될 때까지(본건 거래 이행 여부에 불문함) 본 약관의 적용을 받는다.  

베스티에르 콜렉티브는 통지 없이, 또한 자신의 결정에 대한 이유를 설명하거나 이에 따른 책임을 부담하지 아니하고 언제라도 일반약관을 수정할 자격을 가진다. 본 약관의 어느 조항이 중대하게 변경되는 경우, 사전에 약관에 동의한 이용자들도 본 약관의 신규버전에 동의해야 한다. 일반약관 에 대한 변경의 성격에 따라, 이용자가 이 웹사이트를 이용하고/-하거나 상품을 구매한 날짜에 유 효한 일반약관이 적용된다. 

15. 서비스 정지 및 취소 

본 약관의 하나 이상의 조항을 준수하지 않은 경우(소정의 기간 내에 지급하여야 하는 금원을 지급 하지 않거나 본 약관을 위반하는 경우 등)(베스티에르 콜렉티브가 이를 발견하거나 다른 이용자들 이 타당한 불만을 제기하는지 여부를 불문함), 베스티에르 콜렉티브는 (예컨대) 문제 상황이 시정 될 때까지 잠정적으로 베스티에르 콜렉티브의 서비스에 대한 이용자의 액세스를 정지할 수 있다. 

시정가능한 위반이나 베스티에르 콜렉티브가 발견한 문제를 통지한 후 2일 내에 그러한 시정이 이 루어지지 아니한 경우, 베스티에르 콜렉티브는 이용자가 서비스에 액세스하는 것을 영구적으로 금지할 권리를 가진다. 베스티에르 콜렉티브가 자신이 부담한 손실이나 손해에 대해 청구할 수 있 는 보상에도 불구하고, 이러한 이용자의 액세스에 대한 확정적인 취소는 다른 절차 없이 관련 이용 자에게 해당 조치 및 그러한 조치를 취하는 이유에 대해 고지하는 이메일을 전송한 후에 이루어진 다. 

또한, 이용자의 행동이 본 약관의 중대한 위반(복수의 계정 개설, 결제방식의 부정사용, 사기 시도 또는 범죄행위를 포함하되 이에 한정되지 않음)에 해당하는 경우, 베스티에르 콜렉티브는 제공된 서비스를 정당하게 사전 통지 없이 정지시킬 수 있다(즉시 효력이 발생함). 그러한 조치는 베스티 에르 콜렉티브로부터 여하한 보상청구권을 발생시키지 아니하며, 베스티에르 콜렉티브는 자신이 부담한 손실이나 손해에 대해 보상을 청구할 자격을 가진다. 

베스티에르 콜렉티브가 본건 거래(들)를 취소하는 경우, 이용자들은 자동적으로 현금으로 환불을 받는다(결제를 위해 사용된 카드나 PayPal 계정으로 전액 입금됨). 

16. 불만 

이 웹사이트에 관하여 베스티에르 콜렉티브에 불만을 제기하고자 하는 이용자는 상기 명시된 주 소로 베스티에르 콜렉티브에 서신을 발송하거나 http://faq.vestiairecollective.com 에 게시된 FAQ문의양식으로 요청을 제출하거나 베스티에르 콜렉티브 상담전화 +33 [0]9 70 25 37 37로 연락할 수 있다.  

17. 조정 


이용자 및 베스티에르 콜렉티브 간에 분쟁이 발생하는 경우, 베스티에르 콜렉티브는 이용자가 우 호적으로 분쟁을 해결하도록 시도하기 위해 베스티에르 콜렉티브에 연락할 것을 권장한다. 베스 티에르 콜렉티브는 이러한 면에서 대체분쟁해결방식(조정이나 분쟁 등)의 존재에 대해 이용자에 게 고지한다. 베스티에르 콜렉티브는 전자상거래 관련 분쟁에 대한 조정 서비스를 제공하는 프랑 스의 전자상거래협회(Fédération du e-commerce et de la vente à distance – FEVAD)(FEVAD의 전자상 거래 조정팀, 60 rue la Boétie, 75008 Paris, France – http://mediateurfevad.fr)의 회원사이다. 베스티에 르 콜렉티브는 FEVAD의 전자상거래 및 통신판매에 대한 행동강령을 준수할 것을 확약한다. 

이용자는 ht[tp://www.fevad.com ](http://www.fevad.com)웹사이트에서 언제든지 이러한 문서를 열람할 수 있다.  

또한, 이용자는 htt[p://ec.europa.eu/consumers/odr/에서](http://ec.europa.eu/consumers/odr/) 유럽위원회의 온라인 분쟁해결 플랫폼을 이 용할 수 있다.  

18. 준거법 및 분쟁해결 

본 약관은 프랑스법에 의해 규율된다. 국제물품매매계약에 관한 유엔협약은 본 약관에 적용되지 아니한다.  

당사자들이 분쟁을 우호적으로 해결하지 못하는 경우, 베스티에르 콜렉티브 및 이용자는 해당 분 쟁을 프랑스 법원의 관할로 하는 데 동의한다. 본 약관의 어떠한 내용도 EU에 거주하는 소비자로 서 거주국의 현지법의 강행규정에 의존할 이용자의 권리에 영향을 미치지 아니한다. 

본 조의 조건으로 인해 소비자로부터 자신이 거주하거나 소재하는 국가에서 소송을 제기하거나 소송에서 자신을 방어할 권리를 박탈하거나 거주국의 관련 규칙 및 규정에 명시된 소비자를 위한 보호조치를 박탈하지 아니한다. 

철회 양식 ![](Aspose.Words.67530dd0-4666-4ea0-9c17-12cc801f4c51.003.png)

(계약을 철회하고자 하는 경우, 본 양식을 작성하여 당사로 송부해 주시기 바랍니다.) 

수신인: 베스티에르 콜렉티브, 255 boulevard Pereire, 75017 Paris, France. 

본인은 다음 서비스 제공에 관한 계약을 철회하고자 하는 본인의 결정을 귀사에 통지합니다: 주문번호…………….의 일부로 …………… 상품을 베스티에르 콜렉티브 웹사이트에서 전문 판

매자로부터 구매 

주문일:  이용자 성명:   이용자 주소: 

날짜:   /   /\_  

이용자 서명(본 양식을 종이버전으로 통지하는 경우에 한함): 


# 판매자용 일반약관

해당 조건들은 상품을 판매하기 위해 당사 서비스를 이용하는 이용자들에게 적용됩니다.

“판매자”용 일반약관 


2021년 4월 7일 

중요사항: 본 일반약관은 2020년 12월 9일 효력이 발생하는 업데이트를 전제로 합니다. 이 업데이트는 판매자의 지급조건(제10.3조)에 관한 것으로, 전자지갑의 비활성화를 반영합니다. 

서문 

본 일반약관(“본 약관”)은 이 웹사이트를 이용하여 상품을 판매하는 이용자들에게 적용됩니다. 

베스티에르  콜렉티브는  프랑스에서  설립된  공개유한회사로  255  boulevard  Pereire,  75017  Paris, France에 등록된 주소를 두고 있으며, 프랑스 파리에서 517 465 225호로 등록되어 있습니다. 베스 티에르 콜렉티브는 http:[//www.vestiairecollective.com 웹사이트](https://es.vestiairecollective.com/documents/cgu-mangopay-es.pdf) 및 베스티에르 콜렉티브 스마트폰 애플리케이션(“이 웹사이트”)에 대한 모든 권리를 소유합니다. 

베스티에르 콜렉티브는 이 웹사이트를 통해 베스티에르 콜렉티브가 운영· 관리하는 다양한 서비 스를 제공하고 있습니다. 이 서비스를 통해 웹사이트 이용자들(“이용자들”)은 중고 패션 상품(“상 품”)을 거래할 수 있습니다. 이러한 서비스는 이 웹사이트에서 직접 이용할 수 있습니다. 베스티에 르 콜렉티브는 예외적인 상황에서 자체적으로 직접 상품을 판매할 수 있으며, 이 경우 해당 상품은 이 웹사이트에서 베스티에르 콜렉티브가 판매하는 것으로 표시됩니다.  

본 약관은 베스티에르 콜렉티브와 이용자가 공동으로 명시적으로 승인하지 않은 기타 일반약관이 나 특별약관에 우선합니다.  

2020년 12월 9일 기준으로 적용되는 업데이트: 

판매자는 베스티에르 콜렉티브의 서비스를 이용함으로써 판매자의 결제 거래를 위해 베스티에르 콜렉티브가 이용하는 결제대행사인 PayPal(Hyperwallet)의 조건에 동의합니다. 이러한 PayPal 조건 은 다음에서 확인할 수 있습니다: <https://www.paylution.com/hw2web/consumer/page/legalAgreement.xhtml> 

본 약관은 (해당되는 경우) [프리미엄 서비스 가입약관, ](https://www.vestiairecollective.com/documents/cgu-premium-en.pdf)소개에 관한 [규칙 및 본 약관에 언급된](https://www.vestiairecollective.com/documents/cgu-sponsorship-en.pdf) 기타 서류에 의해 보충될 수 있습니다. 이러한 추가 계약조건이 적용되는 경우, 해당 추가 계약조건은 정당하게 본 약관에 편입된 것으로 간주됩니다. 또한 베스티에르 콜렉티브의 개인정보보호방침

[및 쿠키를](https://www.vestiairecollective.com/privacy-policy/) 숙독하시기 바랍니다. 

이 웹사이트에서 이루어지는 판매에 적용되는 약관 

1. 베스티에르 콜렉티브의 역할 및 책임 

이 웹사이트에서 판매가 제안된 특정 상품에 대해 달리 명시된 경우를 제외하고, 이용자들은 베스 티에르 콜렉티브의 역할이 이용자들 간의 중개 플랫폼 역할을 하는 것으로 제한됨을 확인한다. 따 라서, 특정 경우를 제외하고, 베스티에르 콜렉티브는 상품의 리셀러로 행위하지 아니하며 어느 시 점에도 상품의 소유자가 되지 아니한다. 이용자들은 언제라도 각자 자신을 위해 행위하며, 베스티 에르 콜렉티브의 대리인 또는 대표자로 행위하지 아니한다. 베스티에르 콜렉티브는 구매자와 판 매자 간 판매계약의 당사자가 아니며, 이에 해당 계약 또는 그 결과에 대한 책임을 부인한다. 

베스티에르 콜렉티브가 수행하는 품질관리는 단순히 판매자가 판매하는 상품이 해당 판매자가 작 성한 상품페이지의 설명과 일치하도록 하는 것에 불과하다. 또한, 베스티에르 콜렉티브가 배송을 주선하고 그 협력업체들이 이를 이행하는 것이 베스티에르 콜렉티브가 판매자와 구매자 간 계약 의 당사자임을 의미하지 아니한다. 

베스티에르 콜렉티브에 책임을 물을 수 있는 상품의 배송지연 또는 배송불이행에 대한 불만사항 을 제외하고, 온라인에 광고된 상품 또는 그 설명과 관련된 모든 클레임 또는 불만, 상품페이지에 관한 이용자의 의견 및/또는 판매자의 상품 발송 및 배송(이러한 배송이 상품의 판매, 교환 또는 반 품의 일환인지의 여부를 불문함)에 대한 답변은 판매자의 소관이며, 이러한 종류의 클레임 또는 불 만은 이를 처리할 단독 책임을 지는 판매자에게 전달된다. 

2. 전자지갑 

베스티에르 콜렉티브는 더 이상 전자지갑을 사용할 수 없음을 판매자에게 재차 고지한다. 

3. 상품 판매 

3.1. 권한위임 

베스티에르 콜렉티브가 수행하는 온라인 중개서비스의 범위 내에서, 판매자는 이에 베스티에르 콜렉티브에 다음을 수행할 수 있는 권한을 위임한다: 

- 판매자가 포함시킨 모든 콘텐츠를 포함하여 상품 판매 제안에 해당하는 상품페이지를 이 웹사이트에 게시하고, 해당되는 경우 그 배경을 삭제하는 범위 내에서 상품의 사진을 변경 하는 일; 
- 판매자를 대리하여 구매자가 발주한 주문을 수락하는 일; 
- 판매자를 대리하여 베스티에르 콜렉티브의 장부에 별도의 계정을 개설하는 일 및 해당 계 정에 상품 가격을 입금하는 일; 및 
- 당사자들 간에 미정산금이 있는 경우, 본 약관 제10조에 명시된 바와 같이 해당 금액을 수 령하고 수수료 및 기타 지급금액을 차감한 후 이를 판매자에 송금하는 일. 

3.2. 상품페이지 생성 및 수정 

3.2.1. 상품페이지 생성 

이용자가 판매하고자 하는 각 상품에 대해 상품페이지를 작성해야 한다. 판매자는 상품의 모든 특 성을 정확하게 설명하고 상품페이지에 그 가격을 기재해야 한다. 각 상품의 최소 가격은 22 유로이 다. 

상품페이지에 언급된 상품의 특성 및 특히 상품의 상태는 베스티에르 콜렉티브가 검증하기 전에 판매자가 설명한 특성과 일치해야 한다.  

판매가 제안된 상품은 이 웹사이트에 상품페이지가 게시되어 있는 한 구매자가 주문할 수 있어야 한다. 판매자는 판매 광고된 상품의 주문이 이루어지지 않은 경우 상품페이지를 삭제하여 언제라 도 해당 상품을 이 웹사이트에서 영구적으로 제거할 수 있다. 

판매자는 상품의 특성, 그 브랜드 및 하자, 손상·마모, 또는 해당 상품 구매 당시 구매자가 합리적 으로 알고자 하는 상품의 기타 특성을 포괄적이며 정직하고 정확하게 설명하기로 한다. 판매자는 상품 설명을 변경하여 게시하지 않기로 한다. 상품이 판매되기 전에 눈에 띄는 변경 사항(맞춤화, 개인화 등)이 있는 경우, 판매자는 상품페이지에 이를 명시하기로 한다. 

베스티에르 콜렉티브는 이 웹사이트에서 판매되는 상품의 일관성을 보장하기 위해 이 웹사이트에 서 온라인에 게시되기 전에 판매자의 상품페이지를 수락 또는 거부할 권리가 있다. 상품페이지를 수락할 경우, 베스티에르 콜렉티브는 해당 가격에서 공제되는 수수료를 명시한 가격 관련 이메일 을 판매자에게 송부한다. 

3.2.2. 상품페이지 수정 

판매자는 이러한 목적을 위해 지정된 공간에 코멘트를 추가할 수 있다. 또한, 판매자는 이 웹사이 트에 상품페이지를 게시한 후 이 웹사이트에 올려진 상품의 다른 사진들을 추가할 수 있다. 이미지 를 추가할 경우 베스티에르 콜렉티브의 확인을 받아야 한다. 

상품페이지의 수정은 진행 중인 거래, 즉 구매자가 상품을 주문한 후에는 적용되지 아니한다. 

판매자는 상품의 가격을 인하할 수 있으며, 이 경우 베스티에르 콜렉티브의 수수료는 본 약관 하단 에 표시된 수수료 체계에 따라 조정되며, 이전의 가격은 상품페이지에서 취소선으로 표시되어야 한다. 

베스티에르 콜렉티브는 판매자가 이 웹사이트에 게시된 다른 상품들의 가격 및 시장의 일반적인 기대에 부합하도록 상품의 가격을 변경할 것을 제안할 수 있다. 그에 따라, 판매자는 판매자의 상 품 가격을 선의에 따라 베스티에르 콜렉티브와 논의하기로 한다. 베스티에르 콜렉티브의 가격 변 경은 판매자가 이를 수락하는 경우에만 효력이 발생한다. 명확히 하자면, 상품 가격은 판매자가 결 정한다. 

판매 과정 전반에 걸쳐, 판매자는 가격 및 그에 해당되는 수수료에 대해 완전한 가시성이 있어야 한다. 이 웹사이트에 판매하기 위해 상품을 광고하거나 상품 가격을 인하하기 전에, 판매자는 매번 해당 가격 및 베스티에르 콜렉티브의 수수료를 수락함을 확인해야 한다. 

4. “오퍼하기” 기능 

“오퍼하기” 기능을 통해 구매자는 판매자에게 오퍼를 보내 상품의 가격을 비밀리에 협상할 수 있 으며, 판매자는 이를 수락 또는 거부하거나 구매자에게 카운터오퍼를 할 수 있다. 

오퍼의 일환으로 제안된 가격은 상품 가격의 70% 이상이어야 하나 상품 가격을 초과할 수 없다. 

5. 베스티에르 콜렉티브가 상품을 직접 취득할 수 있는 옵션 

예외적인 경우, 베스티에르 콜렉티브는 상품 데이터 시트를 분석하고 가격에 대해 협상한 후 판매 자의 상품을 직접 취득할 것을 제안할 수 있다.  

6. 상품의 컴플라이언스 확인 

베스티에르 콜렉티브가 구매자가 구매한 상품의 배송을 주선하는 업무를 담당하는 경우 베스티에 르 콜렉티브가 실시하는 컴플라이언스 확인 당시, 해당 상품이 판매자가 작성한 상품페이지(상품 의 상태 등)와 불일치함을 베스티에르 콜렉티브가 알게 된 경우, 베스티에르 콜렉티브는 구매자의 재량에 따라 (i) 판매자 및 구매자와 협상하여 가격이 인하되게 하거나, 또는 (ii) 본건 거래를 취소 하고 구매자에게 환불하기로 한다. 

본건 거래가 취소되는 경우 및 판매자가 상품의 반환을 희망할 경우, 베스티에르 콜렉티브는 최소 처리비용(베스티에르 콜렉티브에 상품을 발송하는 비용, 사진에서 배경을 제거하는 비용, 판매자 에게 상품을 반송하는 비용)에 해당하는 불일치 및/또는 위조 품목 당 세금을 포함한 고정 수수료 12파운드를 판매자에게 청구한다. 

7. 상품 배송 불가에 따른 결과 

7.1. 베스티에르 콜렉티브를 통해 발송되는 경우 

판매자가 제공한 주소가 부정확하거나 수취인의 인수거절로 소포가 반송되는 경우 등 불일치 상 품을 판매자에게 반환할 수 없는 경우, 해당 상품의 판매자에게 이메일을 발송하고 전화를 해야 한 다. 회신이 없는 경우, 해당 상품은 베스티에르 콜렉티브의 후속 이메일을 발송한 시점부터 6개월 동안 판매자의 위험 및 비용(보관 및 처리 비용 포함) 부담으로 판매자의 처분에 따라 보관된다.  

판매자가 해당 상품을 회수하고자 하는 경우, 아래 제12조에 기재된 주소로 수령확인서가 포함된 등기우편 서신으로 베스티에르 콜렉티브에 요청해야 하며, 최소취급비용에 해당하는 세금을 포함 한 12유로(또는 그에 상응하는 현지 통화금액)를 송금해야 한다. 해당 지급금 수령 후, 베스티에르 콜렉티브는 15영업일 내에 해당 상품을 판매자에게 반송한다. 

상기 언급된 6개월의 기간 내에 베스티에르 콜렉티브로부터 상품이 회수되지 않는 경우, 베스티에 르 콜렉티브는 미회수된 상품의 소유자가 된다. 판매자에게 최종적으로 연락을 시도하여 8일 이내 에 회신이 없는 경우, 해당 상품은 파기되거나, 기부가능한 상태인 경우 자선단체에 기부된다. 

7.2. 판매자가 발송한 경우 

구매자가 제공한 주소가 부정확하거나 구매자의 인수거절로 소포가 반송된 경우 등 구매자에게 상품을 인도할 수 없는 경우, 해당 소포는 판매자가 선정한 운송인의 조건에 따라 판매자에게 반환 된다. 

8. 판매자의 약정 및 의무 

판매자는 자신이 단독 소유자인 상품만을 판매하거나, 중고 상품을 위탁 판매하는 경우 상품의 소 유자를 대리하여 해당 상품을 판매하기로 한다. 판매자는 이에 어떠한 방식으로도 현행 법률 및 규 정을 위반하지 아니하며, 베스티에르 콜렉티브에 상품페이지를 제출하거나 이 웹사이트를 통해 상품을 판매함으로써 제3자의 권리를 침해하지 아니함을 진술한다. 

판매자는 (i) 이 웹사이트에서 제공한 상품의 원산지, 상태 및 특성이 해당 상품페이지의 상품 설명 과 일치하며, (ii) 판매되는 상품이 위조품이 아님을 보장, 진술 및 확약한다.  

베스티에르 콜렉티브가 요청하는 경우, 판매자는 판매되는 상품에 대한 소유권 및/또는 해당 상품 의 원산지를 입증하는 모든 서류를 즉시 베스티에르 콜렉티브에 제공해야 한다. 베스티에르 콜렉 티브는 판매되는 상품(들)에 대한 소유권 및/또는 해당 상품(들)의 원산지에 대한 증거를 베스티에 르 콜렉티브에 제공하지 아니한 판매자의 프로필 및/또는 상품페이지를 삭제할 권리가 있다. 베스 티에르 콜렉티브가 상기 언급된 사유로 이러한 정보를 삭제한 경우, 판매자는 이에 대한 보상청구 권을 주장할 수 없다. 

판매자는 상품의 판매에 대해 단독 책임을 부담한다. 판매자는 판매가 금지되거나 현행 법률 및 규 정을 위반하고/-하거나 제3자들의 권리를 침해하는 상품을 판매할 수 없다. 

베스티에르 콜렉티브가 금지품목 해당 여부를 확인할 수 없음을 감안하여, 판매자는 시제품(시리 즈로 생산되기 전에 만들어진 의류 또는 액세서리), 유니폼(특정 브랜드의 직원이 사용하도록 디 자인된 의류 또는 액세서리) 또는 재판매가 허용되지 않는 “직원용 판매” 또는 “프레스 판매(press sales)” 등에 포함되는 상품을 판매하지 않기로 한다. 베스티에르 콜렉티브가 위의 해당 상품이 이 웹사이트에서 판매되고 있음을 알게 되는 경우, 관련 상품의 상품페이지 및/또는 그 판매자의 프로 필이 정당하게 삭제될 수 있으며, 판매자는 보상청구권을 주장할 수 없다. 

판매자의 상품페이지가 업로드되면, 판매자는 진행 중인 모든 거래의 재고를 조사하고 모니터링 하기 위해 정기적으로 자신의 계정에 액세스해야 한다. 판매자가 장기간 자신의 계정에 접속 및 모 니터링할 수 없는 경우, 판매자는 해당 상품의 상품페이지에서 “휴가 중입니다” 버튼을 직접 클릭 하여 잠재적 구매자에게 이행기간 연장을 고지하여야 한다. 판매자는 복귀 시 “휴가에서 돌아왔습 니다” 녹색 버튼을 클릭하여 판매를 재개할 수 있다.  

9. 수수료 계산 

베스티에르 콜렉티브가 제공하는 서비스에 대해 수수료를 지급하여야 하며, 베스티에르 콜렉티브 는 구매자가 지급하는 상품 가격에서 이를 공제한다. 

베스티에르 콜렉티브는 아래 설명된 고정 수수료 원칙이 적용되지 않는 사업자 판매자에 의한 판 매 또는 다시 판매되는 상품의 판매에 대하여 본 약관 하단에 표시된 수수료 체계를 이용하여 이 수수료를 계산한다. 

베스티에르 콜렉티브가 수령하는 수수료는 판매자와 구매자 간의 중개 서비스 및 해당되는 경우 상품의 확인 및 배송에 대한 대가로 각 본건 거래에 대해 구매자가 베스티에르 콜렉티브에 지급한 금액과 일치한다. 이 수수료는 이 웹사이트에 명시된 상품의 판매 가격에 포함된다. 

이러한 수수료 계산 방법은 2019년 4월 3일 전에 판매가 제안된 상품을 포함하여 이 웹사이트에서 판매되는 모든 상품에 적용된다. 

새로운 수수료 체계가 채택되는 경우, (판매자가 이전에 지급한 수수료와 새로운 수수료 체계에 따 른 수수료 간에 차이가 있음을 발견하는 경우 등에) 이전에 완료된 본건 거래에 대해서는 환불이 이루어지지 않음을 확인한다.  

프리미엄 서비스를 통해 판매가 제안된 품목의 경우, 베스티에르 콜렉티브의 프리미엄 서비스 이 [용약관이](https://www.vestiairecollective.com/documents/cgu-premium-en.pdf) 적용된다. “표준서비스”를 통해 판매가 제안되었던 상품이 이후 “프리미엄 서비스”를 통 해 다시 제안되는 경우, “프리미엄 서비스” 이용약관이 우선한다. 

10. 상품 판매 및 판매자에 대한 지급 

10.1. 주문확인과정

판매자는 사기방지 담당 파트너가 구매자의 주문에 관한 정보를 자동으로 처리함을 알고 있으며 이러한 자동정보처리의 목적이 은행카드 사기를 방지하기 위한 것임을 확인한다. 

사기방지 담당 파트너 및/또는 베스티에르 콜렉티브의 “위험” 관리 부서는 상품 발송 전에 주문을 확인하기 위해 구매자에게 전화, 이메일 또는 우편으로 이러한 확인을 실시할 수 있으며, 이러한 확인에는 추가 증거에 대한 요청이 포함될 수 있다. 

이러한 확인에 따라, 구매자가 제공한 정보에 고의적으로 오류가 있고/있거나 사기인 경우 베스티 에르 콜렉티브는 주문 확인 후에도 해당 주문을 취소할 수 있다. 이 경우, 베스티에르 콜렉티브가 취한 조치에 대해 이메일로 구매자에게 통지하며, 베스티에르 콜렉티브는 해당 상품을 판매자의 계정에서 다시 판매하도록 한다.  

10.2. 상품의 발송 및 배송 

10.2.1 판매자가 구매자에 직접 발송하는 상품 

일부 판매자는 특정 조건에 의거하여 구매자의 선택에 따라 구매자에게 직접 상품을 배송할 수 있 다. 아래 주소에서 제공되는 “소비자 정보”란에 기재된 “트러스티드 벤더(Trusted Vendor)” 또는 “엑 스퍼트  벤더(Expert  Vendor)”의  지위를  취득한  판매자만  직접  배송을  할  수  있다:  https:// [fr.vestiairecollective.com/information-consommateur.shtml](https://fr.vestiairecollective.com/information-consommateur.shtml) 

2020년 3월 18일부터 무기한으로, 모든 상품은 판매자의 지위에 관계없이 판매자에 의해 직접 발 송된다.  

구매자가 주문한 상품의 판매자에게는, 해당 상품페이지에 기재된 내용의 이행을 확인하기 위하 여, 구매자에게 상품을 발송하도록 알리는 판매 통지가 이메일로 제공된다. 이러한 이메일에는 판 매자가 요금 부담 없이 상품을 구매자에게 발송할 수 있는 선납 우편요금 바우처가 포함되어야 한 다.   

이러한 선납 우편요금 바우처는 프랑스 본토와 모나코(Colissimo 이용), 영국과 독일(DHL 이용) 또 는 오스트리아, 벨기에, 룩셈부르크, 네덜란드, 포르투갈, 덴마크, 이탈리아, 스페인, 핀란드, 아일 랜드 및 스웨덴(Fedex 이용)에 거주하는 판매자에게만 유효하다.  

판매자는 구매자에게 발송하는 각 품목의 발송에 관한 증빙자료를 보관해야 한다.  

판매자는 판매 확인일로부터 7영업일 내에 (선납 우편요금 바우처를 인쇄한 후) 판매자가 판매하 는 상품을 판매자에 배정된 운송업체를 통해 판매하기 위해 노력해야 한다. 상품 및 이와 함께 판 매된 부속품을 제외한 어떠한 물품도 관련 판촉·홍보자료 없이 동봉하지 아니한다.   

해당 품목이 선납 바우처 없이 발송된 경우, 베스티에르 콜렉티브는 구매자에게 운송되는 과정에 서 상품에 발생한 손상이나 상품의 분실과 관련하여 판매자에게 책임을 지지 아니한다.  

상품이 구매자에게 운송되는 동안 최적의 보험에 의해 보상받을 수 있도록, 판매자는 자신의 비용 으로 운송 과정 중 상품에 발생하는 손상이나 분실을 보상하는 보험계약에 스스로 가입할 수 있다. 이 경우, 판매자는 베스티에르 콜렉티브가 발송한 선납 바우처를 사용해서는 아니된다.  

어떠한 경우라도, 판매자는 주문 과정에서 구매자에 안내된 배송 일정을 준수해야 할 책임이 있다.  

10.2.2. 베스티에르 콜렉티브를 통해 발송되는 상품  

구매자가 주문한 상품의 판매자에게는, 해당 상품페이지에 기재된 내용의 이행을 확인하기 위하 여, 구매자에게 상품을 발송하도록 알리는 판매 통지가 이메일로 제공된다. 이러한 이메일에는 판 매자가 요금 부담 없이 상품을 베스티에르 콜렉티브로 발송할 수 있는 선납 우편요금 바우처가 포 함되어야 한다.   

이러한 선납 우편요금 바우처는 프랑스 본토와 모나코(Colissimo 이용), 영국과 독일(DHL 이용) 또 는 오스트리아, 벨기에, 룩셈부르크, 네덜란드, 포르투갈, 덴마크, 이탈리아, 스페인, 핀란드, 아일 랜드 및 스웨덴(Fedex 이용)에 거주하는 판매자에게만 유효하다.  

상기 지역들 이외의 국가나 프랑스 해외영토 및 자치령(“DOM-TOM”)에 거주하고 있는 판매자는 베스티에르 콜렉티브 컴플라이언스확인부서(compliance checking unit)의 확인이 있을 때까지 자신 의 상품 운송, 취급 및 보험에 관한 모든 비용을 부담해야 한다.  

판매자는 베스티에르 콜렉티브로 발송하는 각 품목의 발송에 관한 증빙자료를 보관해야 한다.  

판매자는 판매 확인일로부터 7영업일 내에 (선납 우편요금 바우처를 인쇄한 후) 판매자가 판매하 는 상품을 판매자에 배정된 운송업체를 통해 판매하기 위해 노력해야 한다. 상품 및 이와 함께 판 매된 부속품을 제외한 어떠한 물품도 관련 판촉·홍보자료 없이 동봉하지 아니한다. 

해당 품목이 선납 바우처 없이 발송된 경우, 베스티에르 콜렉티브는 베스티에르 콜렉티브로 운송 되는 과정에서 상품에 발생한 손상이나 상품의 분실과 관련하여 판매자에게 책임을 지지 아니한 다.  

베스티에르 콜렉티브는 베스티에르 콜렉티브로 발송된 상품을 수령할 때까지 상품의 손상이나 분 실에 대해 책임을 지지 아니한다. 판매자가 상품을 베스티에르 콜렉티브로 발송하기 위해 위탁한 운송업체에 의해 상품에 분실이나 손상이 발생하는 경우, 판매자에 지급되는 보상은 운송업체가 제공하는 보상으로 이루어진다.  

베스티에르 콜렉티브로의 운송 과정에서 상품에 최적의 보험을 제공하기 위하여, 판매자는 자신 의 계획에 따라 비용을 부담하여 베스티에르 콜렉티브로의 운송 과정에서 상품에 발생한 손실이 나 손해를 보장하는 보험계약에 가입할 수 있다. 이 경우, 판매자는 베스티에르 콜렉티브가 발송한 선납 바우처를 사용해서는 아니된다.  

상품이 베스티에르 콜렉티브로 운송되는 동안 최적의 보험에 의해 보상받을 수 있도록, 판매자는 자신의 비용으로 베스티에르 콜렉티브로의 운송 과정 중 상품에 발생하는 손상이나 분실을 보상 하는 보험계약에 스스로 가입할 수 있다. 이 경우, 판매자는 베스티에르 콜렉티브가 발송한 선납 바우처를 사용해서는 아니된다. 

베스티에르 콜렉티브가 상품 판매 확인일로부터 15일 내에 상품을 수령하지 못하는 경우, 베스티 에르 콜렉티브는 해당 상품의 판매를 취소할 수 있으며, 이를 구매자에게 통지해야 한다.  

10.2.3. 배송 시 상품의 상태  

판매자는 완전히 깨끗한 상태(즉, 필요한 경우 세탁 및 다림질된 상태)의 상품만을 배송하기로 한 다. 

베스티에르 콜렉티브를 통해 배송되는 경우, 베스티에르 콜렉티브는 상품의 세탁 및/또는 다림질 을 위해 발생하는 합리적인 발생 비용을 판매자에 청구할 수 있으며, 해당 비용을 베스티에르 콜렉 티브가 판매자에 지급해야 하는 금원에서 공제할 수 있다. 분쟁을 방지하기 위하여, 판매자는 판매 자가 발송하는 상품의 포장에 특별한 주의를 기울이기로 한다(불투명 봉투를 사용하거나 버블랩 (bubble-wrap) 및 탄성 고정장치로 포장을 보강하는 방법 등). 판매자는 발송일로부터 1개월 간 발 송된 품목에 관한 증빙자료를 안전한 장소에 보관한다.  

직접 배송의 경우, 구매자가 불량 상품이 배송되었다고 불만을 제기하는 경우, 베스티에르 콜렉티 브는 구매자의 클레임을 조사한 후 (해당되는 경우) 해당 상품이 판매자에게 즉시 반품될 것임을 판매자에게 통지한다.  

10.3. 판매자의 지급 

베스티에르 콜렉티브 컴플라이언스팀(Compliance Department)이 상품이 상품페이지에 일치함을 확인한 후에 또는 (상품이 베스티에르 콜렉티브를 통해 발송되지 않은 경우) 구매자의 상품 수령 확인일로부터 3일 내에, 구매자로부터 수령한 금원에서 (i) 베스티에르 콜렉티브에 지급되어야 하 는 수수료, (ii) 인증비용, (iii) 운송비용 및 (iv) 베스티에르 콜렉티브에 지급되어야 하는 금액(세탁 및 다림질 비용 등)을 공제한 금액을 판매자가 베스티에르 콜렉티브에 전액 지급해야 한다.  

수수료 체계가 변동되는 경우, 새로운 수수료 체계의 발효일에 진행중인 오퍼는 무효가 된다.  

다만, 다음에 해당되는 경우, 상품이 구매자에 배송된 후 베스티에르 콜렉티브의 요청이 있는 경 우, 판매자는 즉시 본건 거래와 관련하여 베스티에르 콜렉티브로부터 수령한 금액을 상환하고, 운 송비용을 구매자에게 상환해야 한다:  

(i) 본 약관 제10.5조에 명시된 판매자의 의무사항을 위반하여, 상품이 위조품으로 판명되거 나 상품의 판매가 금지된 경우; 또는 

(ii) 사업자 판매자로부터 구매한 상품의 경우, 14일의 법정 기간 동안 구매자가 판매 철회권을 행사하는 경우.  

베스티에르 콜렉티브가 본건 거래와 관련하여 판매자에 여하한 금원을 지급하지 않은 경우, 판매 자는 구매자나 베스티에르 콜렉티브가 정당하게 반품한 상품에 대한 지급을 청구할 수 없다.  

판매자는 이에 본건 거래의 과정에서 베스티에르 콜렉티브가 수령한 금액의 임시 동결로 인해 발 생한 금액(이자 등)에 대한 청구를 포기한다.  

판매자가 자신에게 지급되어야 하는 금액을 계좌이체 방식으로 지급받고자 하는 경우, 판매자가 지정한 은행계좌로 계좌이체가 진행된다. 베스티에르 콜렉티브는 베스티에르 콜렉티브 컴플라이 언스팀이 해당 상품이 상품페이지와 일치함을 확인한 후에 또는 (상품이 베스티에르 콜렉티브를 통해 운송되지 않은 경우) 구매자의 상품 수령확인일로부터 3일 내에 은행이체를 진행해야 한다. 판매자가 판매자의 은행계좌로 계좌이체하는 방식을 선택하는 경우, 프랑스 이외의 국가에 소재 한 계좌의 경우 은행수수료가 청구될 수 있다. 판매자는 해당 은행계좌가 개설된 은행기관에 해당 거래에 적용되는 조건을 확인해야 한다.  

구매자가 클레임이나 불만을 제기하는 경우, 베스티에르 콜렉티브는 해당 클레임이나 불만이 해 결될 때까지 판매자에 대한 지급을 보류할 수 있다.  

판매자는 상품이 상품페이지와 일치함이 확인된 후 (은행의 경우) 약 5영업일 간의 처리 및 취급 지연(이러한 지연 기간은 변동될 수 있으며 정보 목적으로만 이에 명시됨)으로 인해 여하한 금원 이 판매자의 은행계좌나 PayPal 계정으로 즉시 입금되지 않을 수 있음을 확인한다.  

판매자가 베스티에르 콜렉티브에 지급해야 하는 금원을 지급하지 않은 경우, 베스티에르 콜렉티 브는 이를 서면으로 판매자에게 통지한 후 (i) 미지급 금액을 베스티에르 콜렉티브가 판매자에 지 급해야 하는 금액과 상계하고/하거나 (ii) 베스티에르 콜렉티브에 지급되어야 하는 금원이 전액 지 급될 때까지 판매자가 구매 또는 판매한 상품을 압수하고/-하거나 (iii) 신규 본건 거래와 관련하여 자신이 수령하는 금원을 납기가 도래한 금원과 우선적으로 상계할 수 있다. 다만, 이는 판매자가 자신이 구매를 계획하고 있는 새로운 상품을 취득하기 위하여 미지급 잔액을 정산하는 것을 전제 로 한다.  

결제대금을 수령하기 위해, 판매자는 판매자의 은행계좌 정보나 PayPal 계정을 자신의 고객 계정 에 입력하여, 베스티에르 콜렉티브가 판매자의 은행계좌나 PayPal 계정으로 이체할 수 있도록 해 야 한다. 해당 은행에서 이체를 승인하기 위해서는 판매자의 성명이 반드시 은행계좌의 성명과 일 치해야 한다. 판매자가 자신의 PayPal 계정으로의 계좌이체 방식을 선택하는 경우, PayPal 수수료 가 적용될 수 있다. 판매자는 다음 URL에서 자신의 국가에서 적용되는 PayPal 조건들을 확인해야 한다: 여기를 클릭.  

2020년 12월 9일자로 적용되는 업데이트: 

판매자는 베스티에르 콜렉티브의 서비스를 이용함으로써 판매자의 결제 거래를 위해 베스티에르 콜렉티브가 이용하는 결제대행사인 PayPal(Hyperwallet)의 조건에 동의한다. 이러한 PayPal 조건은 다음에서 확인할 수 있다: 

<https://www.paylution.com/hw2web/consumer/page/legalAgreement.xhtml> 

10.4. 유럽경제지역으로 수입된 상품의 판매  

베스티에르 콜렉티브는 유럽경제지역 영토 이외의 지역에 소재하거나 해당 영토 이외의 지역에 소재한 상품의 판매를 제안하는 판매자로 하여금 권리자로부터 취득한 허가를 확인하는 모든 서 류를 제출하도록 요청할 수 있는 권리를 유보한다.  

판매자가 베스티에르 콜렉티브에 해당 서류를 제출하지 않는 경우, 베스티에르 콜렉티브는 본건 거래를 취소하고 판매자의 계정을 정지할 수 있는 권리를 가진다.  

베스티에르 콜렉티브는 판매자가 상품을 베스티에르 콜렉티브로 발송하는 때에 부과되는 관세를 판매자에게 청구할 수 있다.  

10.5. 이 웹사이트상에서 위조품이나 판매가 금지된 상품을 광고하는 경우  

베스티에르 콜렉티브는 인터넷 상에서의 위조품 판매를 금지하는 프랑스 협약인 *Charte de lutte contre la contrefaçon sur Internet*의 가맹사이다. 베스티에르 콜렉티브는 소비자들 및 권리보유자들 모두를 위해 위 협약에 명시된 위조품 판매 방지 조치를 취하기 위한 절차를 적용하기로 한다.  

베스티에르 콜렉티브는 구매자에게 발송하기 전에 상품을 물리적으로 검사하여 위조품이나 판매 가 금지된 상품(현행 법령을 위반하거나 제3자 권리를 침해하는 상품(시제품(시리즈로 생산되기 전에 만들어진 의류 또는 액세서리), 유니폼(특정 브랜드의 직원이 사용하도록 디자인된 의류 또 는 액세서리) 또는 관련 패션회사가 재판매를 허용하지 않는 “직원용 판매” 또는 “프레스 판매 (press sales)” 등으로 발생하는 상품 포함)의 판매를 방지하기 위해 최선의 노력을 기울인다.  

판매자는 판매를 위해 게시한 상품이 위조품이 아니며, 해당 상품의 판매가 금지되지 아니함을 진 술 및 보장한다. 다만, 상품을 물리적으로 조사하기 위한 노력에도 불구하고 구매자가 위조품이나 판매가 금지된 상품을 수령하는 경우, 구매자는 이를 베스티에르 콜렉티브에 반품하고 환불을 받 을 수 있다.  

위조품이나 판매가 금지된 상품이 발견되는 경우, 해당 상품은 즉시 회수 조치되며, 판매자의 계정 은 임시적 또는 영구적으로 정지될 수 있다.  

또한, 위조품이나 판매가 금지된 상품이 이 웹사이트 상에 판매용으로 게시되는 경우, 해당 상품의 판매자는 해당 상품이 관계 당국이나 해당 브랜드 소유자에 의해 압류되어 몰수 또는 폐기될 수 있 는 위험을 부담한다. 이 경우, 판매자는 판매자의 단독 위험으로 비용을 부담하여 해당 상품을 직 접 회수해야 한다.  

위조 행위에는 특정 제재가 적용됨을 확인한다.  

그럼에도 불구하고 위조품이나 판매가 금지된 상품이 판매용으로 게시되거나 관계 당국 또는 관 련 지식재산권을 소유하고 있는 브랜드나 권리보유자에 의해 압류되는 경우, 본건 거래는 취소된 다. 그 후, 판매자는 문제의 상품 판매와 관련하여 판매자가 지급받은 금액을 베스티에르 콜렉티브 에 환불하고, 판매자의 행위로 인하여 베스티에르 콜렉티브 및/또는 구매자가 부담한 비용을 베스 티에르 콜렉티브에 보상해야 한다. 또한, 구매자는 문제의 상품과 관련하여 발생하는 모든 법적 소 송에 관해 베스티에르 콜렉티브가 부담한 모든 비용, 손실, 지출 및 손해에 대한 책임이 있다.  

상품의 진품 여부가 의심되는 경우, 베스티에르 콜렉티브는 판매자로부터 상품의 진품 여부를 확 인하는 제반 서류를 제출하도록 요구하고, 해당 서류를 수령할 때까지 판매자의 계정을 정지할 수 있는 권리를 유보한다. 또한, 베스티에르 콜렉티브는 상품의 진위 여부를 입증하기 위해 판매자와 연락할 수 있다.  

11. 상품 소유권 및 위험의 이전 

상품은 판매자의 자산으로 유지되거나, 베스티에르 콜렉티브가 스스로 자체 상품의 판매자로 행 위하는 경우 베스티에르 콜렉티브가 구매자로부터 주문의 가격(자본 요소 및 부수적 요소(세금, 인증비용, 운송비용 및 적용가능한 모든 기타 비용) 포함)을 전액 지급받을 때까지 베스티에르 콜 렉티브의 자산으로 유지된다. 구매자에 대한 상품의 분실이나 손상 위험의 이전은 구매자나 구매 자가 자신을 대리하도록 위임한 제3자가 상품을 수령하는 때에 이루어진다. 이에 따라, 구매자는 상품 수령 시점부터 상품에 발생한 손상에 관한 위험을 부담한다.  

12. 클레임 및 반품

12.1. 상품 미도착 또는 배송지연 

구매자가 주문일로부터 30일 내에 상품을 수령하지 못하거나 베스티에르 콜렉티브가 이 웹사이트 상에서 직접 자체 상품을 판매하고 있는 경우로, 구매자가 발주 당시 정한 배송일에 상품을 수령하 지 못한 경우, 구매자는 다음 주소로 수령확인증이 동봉된 등기우편으로 서신을 발송하여 본건 거 래를 취소할 수 있다: Vestiaire Collective, 255 boulevard Pereire, 75017 Paris, France. 다만, 이는 구매 자가 우선 합리적인 기한 내에 해당 상황을 개선하기 위해 동일한 방법으로 베스티에르 콜렉티브 에 통지하고, 이러한 추가 기간 내에 배송이 이루어지지 아니하였을 것을 전제로 한다.  

베스티에르 콜렉티브는 본건 거래의 취소를 통지하는 내용으로 수령확인증이 동봉된 등기우편으 로 송부된 서신을 수령한 날로부터 14일 내에 구매자에게 환불해야 한다.  

구매자 본건 거래를 이미 취소하였음에도 불구하고 상품을 수령하는 경우, 구매자는 상품을 반품 하여야 하며, 베스티에르 콜렉티브는 베스티에르 콜렉티브가 상품을 원래의 상태로 완전하게 수 령한 날로부터 14일 내에 반품된 상품의 가격, 인증비용, 운송비용(주문을 전부 반품한 경우) 및 베 스티에르 콜렉티브로의 반품비용을 환불하기로 한다. 이러한 반품은 아래 제12.3.3조의 조건에 따 라 진행된다. 

취소의 경우, 구매자에 대한 환불은 현금으로 이루어진다(구매자가 결제에 사용한 은행카드나 구 매자의 PayPal 계정으로 입금됨). 다만, 각 경우, 이는 베스티에르 콜렉티브가 주문된 상품의 전부 또는 일부 미도착으로 인한 취소 요청이나 환불 요청이 사기에 의한 것이라고 의심하지 않을 것을 전제로 한다. 부분 취소의 경우, 주문 중 취소된 부분에 대해서만 상기 조건에 따라 환불이 이루어 진다.  

12.2. 상품이 해당 상품페이지와 불일치하는 경우  

사업자 판매자로부터의 구매에 따라 발생하는 클레임이나 불만을 베스티에르 콜렉티브가 해결하 는 경우는 관련 절차를 용이하게 하기 위한 것으로, 베스티에르 콜렉티브가 판매 당사자로 간주되 는 결과를 초래하지 아니함을 확인한다.  

12.2.1. 베스티에르 콜렉티브가 수행한 품질관리 중 발견하는 경우 

베스티에르 콜렉티브가 상품이 설명과 부분적으로만 일치함을 발견하는 경우, 구매자의 재량에 따라 베스티에르 콜렉티브는 (i) 판매자와 가격 인하를 협상하거나, (ii) 판매를 취소하고 구매자에 게 환불한다. 구매자 및 판매자가 가격 인하에 합의하는 경우, 가격 인하는 베스티에르 콜렉티브의 대변전표, 구매바우처나 구매자가 사용한 결제방식으로 재입금되는 형식으로 이루어질 수 있다. 

구매자가 제공한 상품페이지의 설명과 불일치하는 상품, 위조품이거나 판매가 금지되는 상품의 경우, 베스티에르 콜렉티브는 본건 거래를 취소하고 구매자에게 환불한다. 

본건 거래가 취소되는 경우, 구매자는 구매자가 처음에 사용한 결제방식으로 현금 환불을 받을 수 있다. 부분 취소의 경우, 취소되는 부분의 본건 주문 만이 상기 조건에 따라 환불된다. 

12.2.2. 구매자가 상품 수령 후 불일치를 발견하는 경우 

(i) 비사업자 판매자로부터 구매한 상품의 경우: 상품이 베스티에르 콜렉티브를 통해 발송된 경우: 

   구매자가 상품이 상품페이지의 설명과 불일치함을 발견하는 경우, 구매자는 상품의 수령 일로부터 14일 내에 이메일을 통해 베스티에르 콜렉티브에 문의해야 한다. 

   구매자는 상품이 상품페이지와 일치하지 않는 방식과 그 정도를 설명하여야 하며, 주장이 입증될 수 있도록 사진을 제공해야 한다. 

   상품이 상품페이지와 일치하지 않는다는 주장이 구매자의 설명 및 사진을 기초로 일견 타 당한 것으로 보이는 경우, 베스티에르 콜렉티브는 구매자가 상품을 반송하도록 승인한다. 

   상품 수령 시, 베스티에르 콜렉티브는 해당 상품이 상품페이지와 실제로 일치하지 않는지 여부를 결정하기 위해 이를 검사한다. 불일치함이 확인되는 경우, 베스티에르 콜렉티브는 구매자에게 환불한다. 환불은 구매자가 처음에 사용한 결제방식으로 입금하여 이루어진 다. 

   상품페이지와 불일치함으로 인해 구매자가 반환한 모든 상품은 베스티에르 콜렉티브가 발 송 시 처음에 상품에 부착한 봉인 양식(라벨)과 함께 반환되어야 한다. 

   구매자가 위조품이나 판매가 금지된 상품을 수령하는 경우, 구매자는 본인 측의 사기의 경 우를 제외하고 해당 상품을 베스티에르 콜렉티브에 반품하고 환불을 받을 수 있다. 

   구매자가 판매자가 직접 배송하는 상품을 선택한 경우: 

   구매자가 상품이 상품페이지의 설명과 불일치함을 발견하는 경우, 구매자는 상품의 수령 일로부터 72시간 내에 이메일을 통해 베스티에르 콜렉티브에 문의해야 한다. 

   구매자는 상품이 상품페이지와 일치하지 않는 방식과 그 정도를 설명하여야 하며, 주장이 입증될 수 있도록 사진을 제공해야 한다. 

   상품이 상품페이지와 일치하지 않는다는 주장이 구매자의 설명 및 사진을 기초로 일견 타 당한 것으로 보이는 경우, 베스티에르 콜렉티브는 구매자가 판매자에게 상품을 반송하도 록 승인한다. 베스티에르 콜렉티브는 판매자가 상품을 수령함을 확인하는 후에 구매자에 게 환불한다. 환불은 구매자가 처음에 사용한 결제방식으로 입금하여 이루어진다. 

(ii) 사업자 판매자로부터 구매한 상품의 경우: 

구매자가 상품이 상품페이지의 설명과 일치하지 아니함을 발견하는 경우, 구매자는 관련 법정 보장에 따라 베스티에르 콜렉티브를 통해 사업자 판매자에게 클레임을 제기할 권리 를 가진다. 

상품페이지의 설명과 일치하지 않는 상품에 대하여 불만을 제기하는 경우, 구매자는 상품 을 반환하거나 회수되도록 이를 제공해야 한다. 

사업자 판매자는 구매자가 해당 상품페이지의 설명과 일치하지 않거나 사업자 판매자의 법적 의무를 충족하지 않음으로 인해 상품을 반환하는 경우, 사업자 판매자가 상기 조건의 적용을 거부할 수 없으며, 합리적인 기간 내에 적절한 조치를 취하여야 함을 확인하고 이에 동의한다. 

구매자가 위조품이나 판매가 금지된 상품을 수령하였다고 판단하는 경우, 구매자는 상품 수령일 로부터 72시간 내에 이메일을 통해 베스티에르 콜렉티브에 알려야 하며, 본인 측의 사기인 경우를 제외하고 환불을 받기 위해 베스티에르 콜렉티브에 상품을 반품할 수 있다. 

본 조의 조항은 베스티에르 콜렉티브로 하여금 판매자 및 구매자 간의 매매의 당사자가 되도록 하 지 아니한다. 판매자가 상품이 해당 상품페이지의 설명과 일치하지 않거나 위조이거나 그 판매가 금지됨을 이유로 구매자가 반품하는 상품과 관련하여 구매자에게 환불하거나 기타 보상을 구매자 에게 지급할 의무를 준수하지 않은 경우, 베스티에르 콜렉티브는 사업자 판매자나 비사업자 판매 자의 본 제12조에 따른 자신들의 의무 준수 불이행에 대한 책임을 부인한다. 

12.3. 사업자 판매자에게 적용되는 특정 조항 

12.3.1. 사업자 판매자의 지위 

사업자 판매자는 이 웹사이트에서 자신을 사업자 판매자로 밝혀야 한다. 베스티에르 콜렉티브는 판매자에게 오해의 소지가 있는 상업적 관행이 엄격하게 금지됨을 재차 고지한다.  

이 웹사이트에 등록하는 경우 또는 등록 후 나중에 지위가 변경되는 경우, 사업자 판매자는 이에 따라 베스티에르 콜렉티브에 그들이 전문가 자격으로 행위함을 알려야 한다. 베스티에르 콜렉티 브는 이러한 사항에 대해 이용자들에게 통지한다. 

사업자 판매자는 표준 수수료 체계의 적용을 받지 아니하며, 위탁판매나 온라인 중개에 대한 그들 의 계약의 일부로서 특정 수수료 규칙으로부터 이익을 얻는다. 

12.3.2. 사업자 판매자의 일반의무 

사업자 판매자(베스티에르 콜렉티브가 이 웹사이트의 이용자들에게 직접 판매하기 위해 자신의 상품을 제안하는 경우, 베스티에르 콜렉티브 포함)은 비사업자 구매자에 대한 상품의 판매와 관련 된 법적 의무를 이행함을 확약하며, 특히 다음과 같은 사항을 확약한다: 

- 구매자가 달리 구매하지 않았을 상품을 구매하도록 하기 위해 이들을 오도할 수 있는 작위 나 부작위를 행하지 아니하며; 
- 관련 규칙 및 규정에 의해 명시된 바에 따라 비사업자 구매자의 철회할 권리 및 구매자가 관련 규칙 및 규정, 특히 관련 법정 보장에 따라 가질 수 있는 기타 모든 권리를 존중하며; 
- 사업자 판매자가 이 웹사이트에서 판매용으로 제안된 상품이 상품페이지의 설명과 일치하 며, 만족할 만한 품질이고, 사업자 판매자가 설명에 명시한 용도나 이러한 종류의 상품이 통상적으로 설계되는 용도에 적합하며, 달리 규정되는 경우를 제외하고 그 자재, 설계 또는 생산에 영향을 미치는 하자가 없도록 하며, 이에 따라 법정 준수보장 및 법정 보장에 따라 구매자에게 잠재적 하자를 보증한다. 

또한, 사업자 판매자는 관할 당국에 관련 규제조항(등록의무 등)을 준수한다는 내용으로 요구되는 모든 신고를 할 책임이 있다. 

베스티에르 콜렉티브는 정기적으로 물품을 판매하고/-하거나 대량의 물품을 판매하는 판매자가 조세당국이나 기타 당국에 의해 사업자 판매자의 자격을 갖출 수 있으므로 관련 규정 및 본 약관으 로 인해 사업자 판매자에게 적용될 수 있는 의무의 적용을 받을 수 있다는 사실을 판매자가 유의하 도록 한다. 관련 규제조항을 준수하기 위해 관할 당국에 필요한 신고를 하는 것을 포함하여 자신들 의 모든 의무를 준수하는 것은 이용자들의 책임이며, 베스티에르 콜렉티브는 이러한 측면의 책임 을 부인한다. 

베스티에르 콜렉티브는 사업자 판매자의 신원 및 연락처에 관한 정보와 신원 문서를 확인하고, 계 정이 존속하는 동안 및 계정 해지 후 5년 동안 이를 보유할 수 있기 위해 사업자 판매자가 그들의 신원 및 주소(프랑스 판매자의 경우: 설립증명서나 신분증, SIRET [회사등록]번호나 SIREN 번호, 프랑스 은행 계좌번호 등)을 확인하는 서류를 제공하도록 요구할 권리를 보유한다. 

12.3.3. 반품 

사업자 판매자는 구매자가 상품을 상품페이지의 설명과 일치하지 않거나 본 약관 및/또는 관련 사 업자 판매자의 법적 의무를 침해함을 이유로 반품하는 경우, 사업자 판매자가 구매자의 재량에 따 라 각 경우 합리적인 기간 내에 구매자에게 상품(및 본건 주문과 관련된 운송비용)을 환불하거나 (합리적으로 가능한 경우) 상품을 수리하는 것을 거부할 수 없음을 확인한다. 

구매자가 구매를 철회할 권리를 행사함으로 인해, 또는 상품에서 일치 여부와 관련된 하자가 발견 되거나, 위조되거나 판매가 금지된 상품으로 인해 본건 거래가 취소되고, 판매자가 관련 상품의 반 품을 희망하는 경우, 판매자는 http://[faq.vestiairecollective.com/hc/fr에 게시된](http://faq.vestiairecollective.com/hc/fr) FAQ 문의양식을 이용 하여 베스티에르 콜렉티브에 알려야 한다. 판매자는 최소취급비용(베스티에르 콜렉티브에 상품 을 발송하는 비용 및 판매자에게 상품을 반송하는 비용)에 상응하는 불일치 및/또는 위조 품목 당 세금을 포함한 고정 수수료 12파운드를 베스티에르 콜렉티브에 지급하여야 하며, 자신이 판매의 일부로 수령한 금원 및 (해당되는 경우) 본건 주문과 관련하여 지급하여야 하는 운송비용을 베스 티에르 콜렉티브에 상환해야 한다. 이 경우, 판매자는 1년 내에 반품을 위해 물품을 회수하고 12유 로(또는 적절한 환율로 전환된 다른 통화로 이에 상응하는 금액)의 수수료를 지급한다. 이 기간 내 에 수수료를 지급하지 않은 경우, 베스티에르 콜렉티브가 필요한 것으로 간주되는 여하한 방식으 로 해당 물품을 폐기할 허가를 자동적으로 부여받게 된다. 

12.3.4. 제안 승인 및 처리에 대한 정보 승인 조건 

   베스티에르 콜렉티브의 유효한 계정을 보유하는 성년인 자는 베스티에르 콜렉티브 플랫폼에서 판 매를 위해 상품을 광고할 수 있다. 계정보유자는 사업자 또는 개인 운영자로 행위할 수 있다. 

   제안 삭제를 규율하는 조건 

   베스티에르 콜렉티브는 다음과 같은 사유로 판매 제안을 게시하지 않거나 삭제할 수 있다: 

- 제안되는 상품이 공중도덕을 위반하거나 그 판매가 법적·규제·계약 조항에 따라 금지되어 베스티 에르 콜렉티브 이용약관에서 의미하는 금지 상품인 경우. 이는 위조품에 해당하거나 선별된·독점 유통망을 위반하여 판매되는 상품 등이 이에 해당된다. 
- 해당 제안의 상품페이지에 오류가 있는 경우; 
- 상품 판매자의 베스티에르 콜렉티브 계정이 그 사유에 불문하고 정지되거나 취소되는 경우; 
- 광고 상품이 이미 판매된 경우. 

  결과페이지 상에서의 판매 제안의 분류 

  기본 분류: 제안은 기본적으로 다음과 같은 요소를 고려하여 당사의 편집팀의 선택에 따라 “당사 의 셀렉션(our selection)”으로 분류된다: 가격, 카테고리(남성/여성), 상품 카테고리(가죽제품, 액세 서리, 의류, 쥬얼리, 빈티지(vintage), 아동, 라이프스타일), 각종 브랜드별. 

  “좋아요(We love)” 분류: “좋아요” 분류에 포함되는 제품은 “패션 관련성” 기준을 충족하는 제품이 다. 이 기준은 이용자들의 특정 관심이나 가치를 반영하는 가장 영감을 주는 제품으로 구성되는 카 탈로그를 편집하기 위해 패션, 고급 및 명품을 선정하는 당사 편집팀의 초이스에 따른 패션 트랜드 를 기반으로 한다. 

  개인 맞춤형 분류: 구매자는 다음과 같은 분류 기준에 따라 판매 제안의 분류를 정하는 다른 기준 을 선택할 수 있다: 

- “최신순”, “오래된 순”: 당사 플랫폼에서 상품페이지의 생성일을 기준으로 상품이 분류된다. 
- “낮은 가격순”: 가장 낮은 가격부터 가장 높은 가격순으로 상품이 분류된다. 
- “높은 가격순”: 가장 높은 가격부터 가장 낮은 가격순으로 상품이 분류된다. 
- “인기순”: 이용자들의 특정 관심이나 가치를 반영하는 가장 영감을 주는 제품으로 구성되는 카탈 로그를 편집하기 위해 패션, 고급 및 명품을 선정하는 당사 편집팀의 초이스에 따른 패션 트랜드를 기준으로 상품이 정렬된다.  

기타 조항 ![](Aspose.Words.6e15eb3d-e5ca-4d0a-b750-df67ad6feefc.004.png)

13. 기간 및 효력 

이용자들은 이 웹사이트 액세스 시 또는 이 웹사이트에 등록 시 본 약관을 승인한 시점부터 자신들 의 계정이 취소될 때까지(본건 거래 이행 여부에 불문함) 본 약관의 적용을 받는다.  

베스티에르 콜렉티브는 통지 없이, 또한 자신의 결정에 대한 이유를 설명하거나 이에 따른 책임을 부담하지 아니하고 언제라도 일반약관을 수정할 자격을 가진다. 본 약관의 어느 조항이 중대하게 변경되는 경우, 사전에 약관에 동의한 이용자들도 본 약관의 신규버전에 동의해야 한다. 일반약관 에 대한 변경의 성격에 따라, 이용자가 이 웹사이트를 이용하고/-하거나 상품을 구매한 날짜에 유 효한 일반약관이 적용된다. 

14. 서비스 정지 및 취소 

본 약관의 하나 이상의 조항을 준수하지 않은 경우(소정의 기간 내에 지급하여야 하는 금원을 지급 하지 않거나 본 약관을 위반하는 경우 등)(베스티에르 콜렉티브가 이를 발견하거나 다른 이용자들 이 타당한 불만을 제기하는지 여부를 불문함), 베스티에르 콜렉티브는 (예컨대) 문제 상황이 시정 될 때까지 잠정적으로 베스티에르 콜렉티브의 서비스에 대한 이용자의 액세스를 정지할 수 있다. 

시정가능한 위반이나 베스티에르 콜렉티브가 발견한 문제를 통지한 후 2일 내에 그러한 시정이 이 루어지지 아니한 경우, 베스티에르 콜렉티브는 이용자가 서비스에 액세스하는 것을 영구적으로 금지할 권리를 가진다. 베스티에르 콜렉티브가 자신이 부담한 손실이나 손해에 대해 청구할 수 있 는 보상에도 불구하고, 이러한 이용자의 액세스에 대한 확정적인 취소는 다른 절차 없이 관련 이용 자에게 해당 조치 및 그러한 조치를 취하는 이유에 대해 고지하는 이메일을 전송한 후에 이루어진 다. 

또한, 이용자의 행동이 본 약관의 중대한 위반(복수의 계정 개설, 결제방식의 부정사용, 사기 시도 또는 범죄행위를 포함하되 이에 한정되지 않음)에 해당하는 경우, 베스티에르 콜렉티브는 제공된 서비스를 정당하게 사전 통지 없이 정지시킬 수 있다(즉시 효력이 발생함). 그러한 조치는 베스티 에르 콜렉티브로부터 여하한 보상청구권을 발생시키지 아니하며, 베스티에르 콜렉티브는 자신이 부담한 손실이나 손해에 대해 보상을 청구할 자격을 가진다. 

베스티에르 콜렉티브가 본건 거래(들)를 취소하는 경우, 이용자들은 자동적으로 현금으로 환불을 받는다(결제를 위해 사용된 카드나 PayPal 계정으로 전액 입금됨). 

15. 불만 

이 웹사이트에 관하여 베스티에르 콜렉티브에 불만을 제기하고자 하는 이용자는 상기 명시된 주 소로 베스티에르 콜렉티브에 서신을 발송하거나 (http://faq.vestiairecollective.com)에 게시된 FAQ 문 의양식으로 요청을 제출하거나 베스티에르 콜렉티브 상담전화 +33 [0]9 70 25 37 37로 연락할 수 있다. 이러한 이메일 주소 및 전화번호는 이용자들이 다른 이용자에 관한 클레임이나 불만을 제기 하기 위해 사용할 수 없으며, 그러한 목적을 위해서는 상기 조항에 명시된 연락정보를 이용해야 한 다. 

16. 조정 

이용자 및 베스티에르 콜렉티브 간에 분쟁이 발생하는 경우, 베스티에르 콜렉티브는 이용자가 우 호적으로 분쟁을 해결하도록 시도하기 위해 베스티에르 콜렉티브에 연락할 것을 권장한다. 베스 티에르 콜렉티브는 이러한 면에서 대체분쟁해결방식(조정이나 분쟁 등)의 존재에 대해 이용자에 게 고지한다. 베스티에르 콜렉티브는 전자상거래 관련 분쟁에 대한 조정 서비스를 제공하는 프랑 스의 전자상거래협회(Fédération du e-commerce et de la vente à distance – FEVAD)(FEVAD의 전자상 거래 조정팀, 60 rue la Boétie, 75008 Paris, France – http://mediateurfevad.fr)의 회원사이다. 베스티에 르 콜렉티브는 FEVAD의 전자상거래 및 통신판매에 대한 행동강령을 준수할 것을 확약한다. 

이용자는 ht[tp://www.fevad.com ](http://www.fevad.com)웹사이트에서 언제든지 이러한 문서를 열람할 수 있다.  

또한, 이용자는 htt[p://ec.europa.eu/consumers/odr/에서](http://ec.europa.eu/consumers/odr/) 유럽위원회의 온라인 분쟁해결 플랫폼을 이 용할 수 있다.  

17. 준거법 및 분쟁해결 

본 약관은 프랑스법에 의해 규율된다. 국제물품매매계약에 관한 유엔협약은 본 약관에 적용되지 아니한다. 본 약관의 어떠한 내용도 EU에 거주하는 소비자로서 거주국의 현지법의 강행규정에 의 존할 이용자의 권리에 영향을 미치지 아니한다. 

당사자들이 분쟁을 우호적으로 해결하지 못하는 경우, 베스티에르 콜렉티브 및 이용자는 해당 분 쟁을 프랑스 법원의 관할로 하는 데 동의한다. 본 조의 조건으로 인해 소비자로부터 자신이 거주하 거나 소재하는 국가에서 소송을 제기하거나 소송에서 자신을 방어할 권리를 박탈하거나 거주국 의 관련 규칙 및 규정에 명시된 소비자를 위한 보호조치를 박탈하지 아니한다. 

수수료 체계:



|통화|가격|수수료|
| - | - | - |
|유로화|0 - 150|15\.00|
|유로화|150 - 300|25%|
|유로화|300 – 1,000|25%|
|유로화|1,000 – 2,000|25%|
|유로화|2,000 – 4,000|23%|
|유로화|4,000 – 5,000|22%|
|유로화|5,000 – 7,500|20%|
|유로화|7,500 +|1,500.00|

2020년 5월 11일 기준, 베스티에르 콜렉티브는 판매가가 150 내지 300파운드인 상품에 대해 다른 수수료를 청구한다. 

수수료는 다음과 같다: 



|통화|가격|수수료|
| - | - | - |
|파운드|0 - 130|13\.00|
|파운드|130 - 140|15%|
|파운드|140 - 150|15%|
|파운드|150 - 160|15%|
|파운드|160 - 170|15%|
|파운드|170 - 180|15%|
|파운드|180 - 190|16%|
|파운드|190 - 200|17%|
|파운드|200 - 210|19%|
|파운드|210 - 220|20%|
|파운드|220 - 230|21%|
|파운드|230 - 240|22%|
|파운드|240 - 250|23%|
|파운드|250 - 260|24%|
|파운드|260 - 870|25%|
파운드| 870 - 1700| 25%  |
파운드| 1700 - 3500 |23% |
파운드| 3500 - 4400 |22% |
파운드| 4400 - 6500 |20% |
파운드| 6500 + |1 300.00|


2021년 2월 3일부터 2021년 3월 17일까지 베스티에르 콜렉티브는 판매가가 300파운드 이하인 상 품에 대해 다른 수수료를 청구한다. 

수수료는 다음과 같다: 



|가격 범위 (파운드)|이전 수수료. (파운드 또는 %)|신규 수수료 (파운드 또는 %)|
| :- | :- | :- |
|0 - 100|£13 |£10|
|100 - 130|£13|10%|
|130 - 180|15%|10%|
|180 - 190|16%|10%|
|190 - 200|17%|10%|
|200 - 210 |19%|15%|
|210 - 220|20%|16%|
|220 - 230|21%|17%|
|230 - 240|22%|18%|
|240 - 250|23%|19%|
|250 - 260|24%|20%|
|260 - 270|25%|21%|
|270 - 280|25%|22%|
|280 - 290|25%|23%|
|290 - 300|25%|24%|
|300 - 1700|25%|25%|
|1700 - 3500|23%|23%|
|3500 - 4400|22%|22%|
|4400 - 6500|20%|20%|
|6500+|£1300|£1300|

2021년 4월 7일로부터 2021년 5월 19일까지 베스티에르 콜렉티브는 판매가가 180파운드 이상인 상품에 대해 다른 수수료를 청구한다. 

수수료는 다음과 같다: 



|가격 범위 (파운드)|이전 수수료. (파운드 또는 %)|<p>수수료 1.0 1분기 </p><p>(파운드 또는 %)</p>|<p>수수료 2.0 2분기. </p><p>(파운드 또는 %)</p>|
| :-: | :- | -: | -: |
|0 - 100|£13|£10|£13|
|100 - 130|£13|10%|£13|
|130 - 180|15%|10%|15%|
|180 - 190|16%|10%|15%|
|190 - 200|17%|10%|15%|
|200 - 210 |19%|15%|15%|
|210 - 220|20%|16%|15%|
|220 - 230|21%|17%|15%|
|230 - 240|22%|18%|15%|
|240 - 250|23%|19%|15%|
|250 - 260|24%|20%|15%|
|260 - 270|25%|21%|15%|
|270 - 280|25%|22%|15%|
|280 - 290|25%|23%|15%|
|290 - 300|25%|24%|15%|
|300 - 500|25%|25%|20%|
|500 - 1700|25%|25%|25%|
|1700 - 3500|23%|23%|25%|
|3500 - 4400|22%|22%|25%|
|4400 - 6500|20%|20%|25%|
|6500 - 7000|£1300|£1300|25%|
|7000+|£1300|£1300|£1750|


# **결제대행 서비스**

해당 조건들은 상품을 판매 및 구매하기 위해 당사 서비스를 이용하는 이용자들에게 적용됩니다.

**제1조 (목적)**

이 약관은 주식회사 아울소싸이어티(이하 '회사'라 함)가 제공하는 샤카라카 결제 서비스(전자지급결제대행 서비스 및 결제대금 예치 서비스)의 이용에 관한 제반 사항과 기타 필요한 사항을 구체적으로 규정함을 목적으로 합니다.

**제2조 (용어의 정의)**

이 약관에서 정하는 용어의 정의는 다음과 같습니다.

1. '샤카라카 결제 서비스'(이하 '서비스'라 함)는 회원 상호 간의 거래의 안전을 위하여 회사가 물품 대금의 입출금을 중개할 목적으로 마련한 절차를 말합니다.

2. '회원'은 이 약관을 승인하고 회사와 서비스 이용계약을 체결한 자를 말합니다.

3. '판매자'는 물품을 판매할 의사로 해당 물품을 회사가 제공한 양식에 맞춰 등록한 회원을 말합니다.

4. '구매자'는 물품을 구매할 의사로 해당 물품의 금액과 수수료를 회사로 보내 물품을 구매하는 회원입니다.

5. ‘안전 거래’ 또는 ‘매매 보호 서비스’ 또는 ‘에스크로는’ 회사가 운영하는 인터넷 사이트에서 회원 상호 간의 거래의 안전을 위하여 회사가 물품 대금의 입출금을 중개할 목적으로 마련한 절차를 말합니다.

위 항목에서 정의되지 않은 약관상 용어의 의미는 일반적인 관행에 의합니다.

**제3조 (약관의 명시, 효력 및 변경)**

1. 회사는 이용자가 서비스를 이용하기 전에 이 약관을 게시하고 회원이 이 약관의 중요한 내용을 확인할 수 있도록 합니다.

2. 회사는 필요에 의해 본 약관을 변경할 수 있으며 변경 사유가 발생할 경우, 변경된 내용을 공지한 후 회원으로부터 이의제기가 없는 1주일이 지나면 자동으로 변경된 약관이 적용됩니다.

3. 이 약관은 서비스를 통하여 이를 공지하거나 문자 메시지 등의 방법으로 회원에게 통지함으로써 효력이 발생합니다.

**제4조 (관련 법령과의 관계)**

1. 이 약관에서 정하지 않은 사항은 전기통신사업법, 전자문서 및 전자거래 기본법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 전자상거래 등에서의 소비자보호에 관한 법률 등 관련 법령의 규정과 일반적인 상관례에 의합니다.

2. 회원은 회사가 제공하는 서비스를 이용함에 있어서 전자상거래 등에서의 소비자보호에 관한 법률 (예시 : 공급서, 표시 광고, 반품, 배송 등 통신판매에 관한 규정), 전자상거래 등에서의 소비자보호에 관한 법률 (예시 : 소비자 보호에 관한 규정), 소비자기본법(예시:사업자의 의무에 관한 규정), 정보통신망 이용촉진 및 정보보호 등에 관한 법률 (예시:개인정보보호에 관한 규정) 등 관련 법령을 준수하여야 하며, 이 약관의 규정을 들어 관련 법령 위반에 대한 면책을 주장할 수 없습니다.

**제5조 (이용 계약의 성립)**

1. 이용 신청 시 "결제대행 서비스 이용약관에 동의"를 선택하면 이 약관에 동의하는 것으로 간주합니다.

2. 회사가 제공하는 서비스를 이용하고자 하는 회원은 회사가 요청하는 양식에 따라 필요사항을 기재하여야 합니다.

**제6조 (개인 정보의 보호 및 사용)**

1. 사용 회사는 개인 정보를 중요하게 생각하고 관리하고 있습니다. 회사의 개인정보보호에 대해서는 개인정보 처리방침을 통해 확인하실 수 있습니다.

2. 회사가 제5조에 따라 요구하는 회원의 개인정보는 본 이용계약의 이행과 본 이용 계약상의 서비스 제공을 위한 목적으로 이용합니다.

3. 회원이 회사 및 회사와 제휴한 서비스들을 편리하게 이용할 수 있도록 하기 위해 회원 정보는 회사와 제휴한 업체에 제공될 수 있습니다. 단, 회사는 회원 정보 제공 이전에 제휴 업체, 제공 목적, 제공할 회원 정보의 내용 등을 사전에 공지하고 회원의 동의를 얻어야 합니다.

4. 회원은 회원 정보 수정을 통해 언제든지 개인 정보에 대한 열람 및 수정을 할 수 있습니다.

5. 회원이 이용신청서에 회원 정보를 기재하고, 회사에 본 약관에 따라 이용신청을 하는 것은 회사가 본 약관에 따라 이용신청서에 기재된 회원 정보를 수집, 이용 및 제공하는 것에 동의하는 것으로 간주합니다.

**제7조 (면책조항)**

1. 회사가 회원들에게 제공하는 서비스는 온라인 거래 장소를 제공하고 기타 부가 정보를 제공함에 그치는 것이므로 서비스를 통하여 이루어지는 회원 상호 간의 거래와 관련된 거래이행, 물품 배송, 청약 철회 또는 반품, 물품하자로 인한 분쟁 해결 등 필요한 사후 처리는 거래당사자인 회원들이 직접 수행하여야 합니다. 회사는 이에 대하여 관여하지 않으며 어떠한 책임도 부담하지 않습니다.

2. 회사는 천재지변 또는 이에 준하는 불가항력, 정보통신설비의 보수점검, 교체 또는 고장, 통신의 두절 등으로 인하여 일시적 또는 종국적으로 서비스를 제공할 수 없는 경우, 서비스 제공에 관한 책임이 면제됩니다. 이 경우 회사는 회사가 제공하는 인터넷사이트 화면에 게시하거나 기타의 방법으로 회원들에게 통지합니다.

3. 회사는 인터넷 이용자 또는 회원의 귀책 사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다.

4. 회사는 서비스를 통하여 거래되는 물품의 하자, 물품등록정보의 오류, 미비 등으로 인하여 회원이 입는 손해에 대해서는 책임(제조물책임 포함)을 지지 않습니다.

5. 회사는 회원이 다른 회원이 게재한 정보, 자료, 사실의 정확성 등을 신뢰함으로써 입은 손해에 대하여 책임을 지지 않습니다.

**제8조 (서비스 이용자의 의무)**

**1. 판매자의 의무**

1) 상품의 등록은 반드시 판매 목적으로, 판매가 가능한 상품만을 등록하여야 하며, 상품의 등록은 회사가 정한 양식에 따라 진행하여야 합니다.

2) 판매 목적의 상품을 등록한 판매자는 구매자의 문의에 성실하고 정확하게 답하여야 합니다. 판매자의 불성실, 부정확한 답변으로 인하여 구매자에게 발생한 손해에 대하여 판매자가 책임을 부담합니다.

3) 판매자는 상품의 매매와 관련하여 관련 법령을 준수하여야 하며, 이 약관 및 회사가 서비스 화면에서 고지하는 내용을 준수하여야 합니다. 관련 법령, 이 약관 및 고지 내용을 위반하거나 이행하지 아니하여 발생하는 모든 손실, 손해에 대하여 판매자가 책임을 부담합니다.

4) 판매자는 상품의 판매와 관련하여 특정한 인허가 자격이 필요한 경우 이에 대한 요건을 완료한 후 판매 상품의 광고를 등록하여야 합니다. 인허가 자격을 갖추지 않은 상태에서 관련 상품의 판매로 인하여 발생한 모든 민형사상의 책임은 판매자가 부담하여야 합니다.

5) 회사는 판매자가 광고 등록한 내용에 대하여 어떠한 보증이나 대리를 하지 않습니다. 따라서 판매자는 상품의 매매와 관련하여 회사가 보증이나 대리를 하였음을 인지하게 하는 내용을 게재하여서는 안 됩니다.

6) 상품은 허위/과장/과대광고, 신용 카드 결제 시스템만을 이용하기 위하여 허위 등록하는 경우 등에 대하여 회사는 해당 광고 상품을 삭제, 취소할 수 있으며, 이에 따른 모든 책임은 해당 상품을 등록한 판매자가 부담하여야 합니다.

7) 판매자는 구매자의 거래 취소 요청이 있는 경우 이를 타당한 이유 없이 거부하여서는 안 되며, 부당한 요금을 요구하여서는 안 됩니다.

8) 판매자는 전자상거래 등에서의 소비자보호에 관한 법률 등 상품의 매매와 관련한 법령에서 정하는 기간 동안 필요 자료를 보관하여야 합니다.

9) 판매자는 구매자와 상품 매매 절차에서 분쟁이 발생한 경우 분쟁의 해결을 위하여 성실히 임하여야 하며, 분쟁 해결의 불성실로 인하여 구매자와 회사에 발생한 모든 손실, 손해를 부담하여야 합니다.
****

**2. 구매자의 의무**

1) 구매자는 구매 의사 없이 판매자의 상품에 구매 표시를 하여서는 안 됩니다. 구매 의사 없이 고의로 판매자의 상품 판매의 기회를 방해하거나 다른 구매자의 구매 기회를 방해한 것이 적발되는 경우 회사는 해당 아이디에 대하여 회원 자격을 정지하는 등의 조치를 할 수 있습니다.

2) 구매자는 상품을 구매하기 전에 반드시 상품의 내용과 거래의 조건을 확인한 후 구매하여야 합니다. 구매하려는 상품의 내용과 거래의 조건을 확인하지 않고 구매하여 발생한 모든 손실, 손해에 대한 책임은 구매자가 부담하여야 합니다.

3) 구매자는 이 약관 및 회사가 서비스 화면에서 고지하는 내용을 준수하여야 하며, 약관 및 고지 내용을 위반하거나 이행하지 아니하여 발생하는 모든 손실, 손해에 대하여 책임을 부담합니다.

4) 회사는 판매자가 등록한 상품의 내용과 거래 조건에 대해서 어떠한 보증이나 대리를 하지 않습니다. 따라서 구매자는 상품 구매 시 자신의 책임하에 상품을 구매하여야 합니다.

5) 구매자는 구매한 상품에 거래 취소 또는 반품의 원인이 발생한 경우 수령한 상품을 임의로 사용하거나 훼손되도록 방치하여서는 안 됩니다. 거래 취소 또는 반품 상품의 임의 사용이나 상품 보관의 미흡으로 인한 상품 훼손에 대하여 합당한 비용을 부담하여야 합니다.

6) 구매자는 판매자와 상품 매매 절차에서 분쟁이 발생한 경우 분쟁의 해결을 위하여 성실히 임하여야 하며, 분쟁 해결의 불성실로 인하여 판매자와 회사에 발생한 모든 손실, 손해를 부담하여야 합니다.

7) 구매자는 상품의 구매 시 결제 방법을 사용함에 있어 반드시 본인 명의의 결제 수단을 사용하여야 하며, 타인의 결제 수단을 임의 사용 하여서는 안 됩니다. 타인의 결제 수단을 임의로 사용함으로써 발생하는 회사, 결제 수단 소유자, 판매자의 손실과 손해에 대한 모든 책임은 구매자가 부담합니다.

**3. 회사의 의무**

1) 회사는 회사가 제공하는 서비스를 이용하는 이용자에게 서비스 이용에 관련한 중요사항을 고지합니다.

2) 회사는 서비스가 안전하게 제공될 수 있도록 각종 설비와 자료를 관리합니다.

3) 회사는 서비스를 이용하는 회원간 분쟁이 발생하여 그 분쟁의 해결이 원활하지 않은 경우 분쟁의 원활한 해결을 위하여 노력합니다.

4) 회사는 회사가 제공하는 서비스가 서비스 제공 목적에 맞게 이용이 되고 있는지를 수시로 확인할 수 있으며, 이용 목적에 위반되거나 벗어난 이용이 확인되는 즉시 관련 이용자에게 사유의 소명을 요청할 수 있으며, 사유의 소명이 타당하지 않다고 판단되는 경우 관련 이용자의 서비스 이용을 제한할 수 있습니다.

5) 회사는 서비스 제공자로서 관련 법령에서 정하는 기간 동안 필요 정보를 보관합니다. 또한 보관 중인 자료에 대하여 당사자의 요청이 있는 경우 관련 자료를 제공할 수 있습니다.

6) 전자적 장치의 운영 장애, 그 밖의 사유로 거래 내용을 제공할 수 없을 때 회사는 회원들에게 이를 즉시 알리며 만일 회원이 자신의 거래 내용을 서면(전자 문서는 제외)으로 제공받기를 원한다면, 회원 본인의 이름, 아이디, 전화번호, 확인하고자 하는 거래정보(가격, 결제일 등) 등을 명시한 서면 자료를 아래 주소지로 등기 우편으로 보내야 합니다.

경기도 수원시 팔달구 효원로 249번길 46-15, 5층 55호 - 샤카라카 운영자 앞
연락처 : 010-7752-5785

**제9조 (제세공과금)**

1. 서비스를 제공함에 있어 회사는 서비스 이용에 따르는 서비스 이용 수수료를 부과합니다.

2. 거래가 정상적으로 완료되어 판매자에게 물품 대금을 송금할 경우, 해당 거래의 결제 수수료 및 부가세를 제외한 금액을 판매자에게 송금합니다.

3. 수수료는 결제 수단에 상관없이 아래와 같이 부과합니다.  

- 수수료: 3.3% (단 1원 단위 미만의 수수료는 부과하지 않습니다.)

4. 위 수수료는 회사가 진행하는 이벤트 등으로 인해 한시적으로 부과하지 않을 수 있습니다.

5.사업자 회원의 정산 시, 결제 수수료와 부가가치세가 공제 됩니다.

**제10조 (분쟁 처리 및 분쟁 조정)**

1. 이용자는 서비스 이용과 관련한 의견 및 불만을 제기 및 거래 분쟁 처리를 요구할 수 있습니다.

2. 이용자가 회사에 대하여 분쟁 처리를 신청한 경우 회사는 15일 이내 이에 대한 조사 또는 처리 결과를 이용자에게 안내합니다.

3. 이용자는 금융위원회의 설치 등에 관한 법률 제51조의 규정에 따른 금융감독원의 금융분쟁조정위원회나 전자상거래 등에서의 소비자보호에 관한 법률 제31조 제1항의 규정에 따른 한국소비자원에 회사의 전자금융거래 서비스의 이용과 관련한 분쟁조정을 신청할 수 있습니다.

**제11조 (서비스 이용 제한)**

1. 회사는 회사가 제공하는 서비스의 원활한 진행 및 회원간 안전한 서비스 이용이 이루어지도록 하기 위하여 일정한 경우 회원자격을 정지할 수 있습니다. 회원자격이 정지된 회원은 회사가 제공하는 서비스의 이용이 제한됩니다.

2. 회사에 의한 회원의 자격의 정지는 일시 정지와 영구 정지로 구분됩니다.

1) 일시 정지

거래를 고의적, 상습적으로 취소하거나 상호 비방, 명예 훼손 등 원활한 거래를 방해하는 행위 등 운영자가 판단에 따라 경고 및 일시 정지 처리됩니다.

2) 영구 정지

신용 카드 부정 사용 행위, 매매 부적합 상품의 매매, 상표권, 저작권, 초상권, 특허권 등의 권리 침해, 타인의 개인 정보 유출 및 제공 목적 외의 이용(스팸 메시지 발송 등), 회원 정보의 허위 등록, 금융 정보의 도용 및 차용, 다른 회원의 정당한 권리의 심각한 침해, 일시 정지 사유의 고의적이거나 반복적 발생, 기타 서비스 이용 규칙의 위반 행위 시에 적용될 수 있습니다.

귀하의 당사 서비스 이용은 <u>[개인정보보호방침 및 쿠키(Privacy Policy & Cookies)](/privacy)</u>에 의해 규율됩니다.


적용일자 2022. 11. 11. 부터.
개정되는 약관에 동의하지 않으시는 경우, 회원 탈퇴가 가능합니다. 
약관에 동의하지 않는다는 별도의 의사 표시가 없는 경우, 개정 사항에 동의한 것으로 간주됩니다.
앞으로 더 좋은 서비스를 만들어가는 샤카라카가 되겠습니다.

감사합니다.
`;

const Terms = () => {
  return (
    <Container>
      <BackHeader title="개인정보 처리방침" />
      <ContentWrapper>
        <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
          {TermsMarkdown}
        </ReactMarkdown>
      </ContentWrapper>
    </Container>
  );
};

export default Terms;
